import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-099475ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container-fluid mb-0 py-3 py-lg-5 bg-gray"
}
const _hoisted_2 = {
  key: 1,
  class: "container py-5"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "fw-bold text-center mb-3 mb-lg-5" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "row mx-0 shadow-lg bg-white p-3 p-lg-5 rounded-4 mx-auto mb-5" }
const _hoisted_9 = { class: "fw-bold fs-6 text-center mb-5" }
const _hoisted_10 = { class: "fw-bold mb-4 fs-6 py-2 px-2" }
const _hoisted_11 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_12 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_13 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_14 = { class: "mx-0 px-0 col-lg-4 d-flex justify-content-between" }
const _hoisted_15 = { class: "flex-basic-80 mx-2 mb-3 mb-lg-0" }
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_18 = { class: "mx-0 px-0 col-lg-4 d-flex justify-content-between" }
const _hoisted_19 = { class: "flex-basic-80 mx-2 mb-3 mb-lg-0" }
const _hoisted_20 = ["placeholder"]
const _hoisted_21 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_22 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_23 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_24 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_25 = { class: "mx-0 px-0 col-lg-4 d-flex justify-content-between" }
const _hoisted_26 = { class: "flex-basic-80 mx-2 mb-3 mb-lg-0" }
const _hoisted_27 = ["placeholder"]
const _hoisted_28 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_29 = { class: "mx-0 px-0 col-lg-4 d-flex justify-content-between" }
const _hoisted_30 = { class: "flex-basic-80 mx-2 mb-3 mb-lg-0" }
const _hoisted_31 = ["placeholder"]
const _hoisted_32 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_33 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_34 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_35 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_36 = { class: "row mx-0 px-0 col-lg-4" }
const _hoisted_37 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_38 = ["placeholder"]
const _hoisted_39 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_40 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_41 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_42 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_43 = { class: "row mx-0 px-0 col-lg-4" }
const _hoisted_44 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_45 = {
  key: 0,
  class: "mt-1 email-same while-spaces"
}
const _hoisted_46 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_47 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_48 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_49 = { class: "mx-0 px-0 col-lg-4" }
const _hoisted_50 = { class: "row" }
const _hoisted_51 = { class: "col-lg-7" }
const _hoisted_52 = { class: "input-group mb-2" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    for: "select-birthday",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_54 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_55 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_56 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_57 = { class: "row mx-0 px-0 col-lg-4" }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_60 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_61 = { class: "col-lg-4 px-2 px-lg-0" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1 px-lg-0 text-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "hyphen-position" }, " - ")
], -1))
const _hoisted_63 = { class: "col-lg-4 px-2 px-lg-0" }
const _hoisted_64 = {
  for: "zipcode_judgment",
  class: "mt-1 ms-2"
}
const _hoisted_65 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_66 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_67 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_68 = { class: "row mx-0 px-0 col-lg-4 d-block" }
const _hoisted_69 = { class: "mx-0 px-0 col-lg-9 d-flex justify-content-between mb-4" }
const _hoisted_70 = { class: "w-max-content col-form-label text-left px-2 col-lg-4" }
const _hoisted_71 = { class: "mx-lg-0 mx-2 mb-3 mb-lg-0 flex-basic-address" }
const _hoisted_72 = ["disabled"]
const _hoisted_73 = { value: "" }
const _hoisted_74 = ["value"]
const _hoisted_75 = { class: "mx-0 px-0 col-lg-9 d-flex justify-content-between" }
const _hoisted_76 = { class: "w-max-content col-form-label text-left px-2 col-lg-4" }
const _hoisted_77 = { class: "col-lg-12 px-2" }
const _hoisted_78 = ["placeholder"]
const _hoisted_79 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_80 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_81 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_82 = {
  id: "phone-number",
  class: "row mx-0 px-0 col-lg-4"
}
const _hoisted_83 = { class: "d-flex" }
const _hoisted_84 = { class: "col-lg-3 px-2 px-lg-0" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1 px-lg-0 text-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "hyphen-position" }, " - ")
], -1))
const _hoisted_86 = { class: "col-lg-3 px-2 px-lg-0" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1 px-lg-0 text-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "hyphen-position" }, " - ")
], -1))
const _hoisted_88 = { class: "col-lg-3 px-2 px-lg-0" }
const _hoisted_89 = { class: "fw-bold mb-4 fs-6 py-2 px-2" }
const _hoisted_90 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_91 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_92 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_93 = { class: "row mx-0 px-0 col-lg-4" }
const _hoisted_94 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_95 = ["placeholder"]
const _hoisted_96 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_97 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_98 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_99 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_100 = { class: "mx-0 px-0 col-lg-4 d-flex justify-content-between" }
const _hoisted_101 = { class: "w-max-content col-form-label text-left px-2" }
const _hoisted_102 = { class: "flex-basic-80 mx-lg-0 mx-2 mb-3 mb-lg-0" }
const _hoisted_103 = { value: "" }
const _hoisted_104 = ["value"]
const _hoisted_105 = { class: "mx-0 px-0 col-lg-4 d-flex justify-content-between" }
const _hoisted_106 = { class: "w-max-content col-form-label text-left px-2" }
const _hoisted_107 = { class: "flex-basic-80 mx-lg-0 mx-2 mb-3 mb-lg-0" }
const _hoisted_108 = { value: "" }
const _hoisted_109 = ["value"]
const _hoisted_110 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_111 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_112 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_113 = { class: "mx-0 px-0 col-lg-4" }
const _hoisted_114 = { class: "row" }
const _hoisted_115 = { class: "col-lg-7 col-8" }
const _hoisted_116 = { class: "input-group mb-2" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    for: "select-birthday",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_118 = { class: "col-lg-5 col-4 align-items-center d-flex justify-content-start mb-2" }
const _hoisted_119 = { class: "row col-lg-12 px-2 px-lg-0" }
const _hoisted_120 = { class: "fw-bold mb-4 fs-6 py-2 px-2" }
const _hoisted_121 = { class: "row mx-0 px-0 pb-4 gx-3" }
const _hoisted_122 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_123 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_124 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_125 = { class: "col-lg-6 mb-3 px-2 px-lg-0" }
const _hoisted_126 = ["placeholder"]
const _hoisted_127 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_128 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_129 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_130 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_131 = { class: "col-lg-6 mb-3 px-2 px-lg-0" }
const _hoisted_132 = ["placeholder"]
const _hoisted_133 = {
  id: "sns-linking-title",
  class: "fw-bold fs-6 p-2 text-lg-start"
}
const _hoisted_134 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_135 = { class: "w-max-content col-lg-2 col-form-label text-black" }
const _hoisted_136 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_137 = { class: "row mx-0 px-0 col-lg-5 align-items-center" }
const _hoisted_138 = { class: "d-flex col-lg-10 px-2 justify-auth" }
const _hoisted_139 = { class: "form-check me-4" }
const _hoisted_140 = { class: "form-check-label fs-7" }
const _hoisted_141 = ["value"]
const _hoisted_142 = { class: "form-check me-4" }
const _hoisted_143 = { class: "form-check-label fs-7" }
const _hoisted_144 = ["value"]
const _hoisted_145 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_146 = { class: "w-max-content col-lg-3 col-form-label text-black" }
const _hoisted_147 = { class: "row mx-0 px-0 col-lg-9" }
const _hoisted_148 = { class: "d-flex col-12 px-2 flex-xl-row flex-column" }
const _hoisted_149 = { class: "col-12 col-xl-6 me-4" }
const _hoisted_150 = ["title"]
const _hoisted_151 = ["title"]
const _hoisted_152 = {
  key: 2,
  class: "col-lg-5 me-4"
}
const _hoisted_153 = ["disabled"]
const _hoisted_154 = {
  key: 1,
  class: "col-form-label fs-7"
}
const _hoisted_155 = {
  key: 0,
  class: "bg-white p-2 p-lg-5 mb-3 mb-lg-5 shadow rounded-4"
}
const _hoisted_156 = { class: "fw-bold fs-6 text-center mb-5" }
const _hoisted_157 = { class: "mb-4 supplementary-text position-relative" }
const _hoisted_158 = ["innerHTML"]
const _hoisted_159 = {
  key: 0,
  class: "fw-bold mb-4 fs-6 py-2 px-2"
}
const _hoisted_160 = {
  key: 1,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_161 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_162 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_163 = { key: 0 }
const _hoisted_164 = { class: "row mx-0 px-0 col-lg-6" }
const _hoisted_165 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_166 = ["placeholder"]
const _hoisted_167 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_168 = {
  key: 2,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_169 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_170 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_171 = { key: 0 }
const _hoisted_172 = { class: "row mx-0 px-0 col-lg-6" }
const _hoisted_173 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_174 = ["placeholder"]
const _hoisted_175 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_176 = {
  key: 3,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_177 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_178 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_179 = { key: 0 }
const _hoisted_180 = { class: "mx-0 px-0 col-lg-9" }
const _hoisted_181 = { class: "row" }
const _hoisted_182 = { class: "col-lg-3" }
const _hoisted_183 = { class: "input-group" }
const _hoisted_184 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    for: "select-birthday",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_185 = { class: "col-lg-1 py-2 py-lg-0 d-flex align-items-center justify-content-lg-center h-38" }
const _hoisted_186 = { class: "col-lg-3" }
const _hoisted_187 = { class: "input-group" }
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    for: "select-birthday",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_189 = {
  key: 4,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_190 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_191 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_192 = { key: 0 }
const _hoisted_193 = { class: "row mx-0 px-0 col-lg-4" }
const _hoisted_194 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_195 = ["placeholder"]
const _hoisted_196 = {
  key: 5,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_197 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_198 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_199 = { key: 0 }
const _hoisted_200 = { class: "row mx-0 px-0 col-lg-4" }
const _hoisted_201 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_202 = {
  key: 6,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_203 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_204 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_205 = { key: 0 }
const _hoisted_206 = { class: "mx-0 px-0 col-lg-4 d-flex justify-content-between" }
const _hoisted_207 = { class: "flex-basic-80 mx-lg-0 mx-2 mb-3 mb-lg-0" }
const _hoisted_208 = ["placeholder"]
const _hoisted_209 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_210 = { class: "mx-0 px-0 col-lg-4 d-flex justify-content-between" }
const _hoisted_211 = { class: "flex-basic-80 mx-lg-0 mx-2 mb-3 mb-lg-0" }
const _hoisted_212 = ["placeholder"]
const _hoisted_213 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_214 = {
  key: 7,
  class: "fw-bold mb-4 fs-6 py-2 px-2"
}
const _hoisted_215 = {
  key: 8,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_216 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_217 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_218 = { key: 0 }
const _hoisted_219 = { class: "row mx-0 px-0 col-lg-6" }
const _hoisted_220 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_221 = ["placeholder"]
const _hoisted_222 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_223 = {
  key: 9,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_224 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_225 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_226 = { key: 0 }
const _hoisted_227 = { class: "row mx-0 px-0 col-lg-6" }
const _hoisted_228 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_229 = ["placeholder"]
const _hoisted_230 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_231 = {
  key: 10,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_232 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_233 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_234 = { key: 0 }
const _hoisted_235 = { class: "row mx-0 px-0 col-lg-6" }
const _hoisted_236 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_237 = ["placeholder"]
const _hoisted_238 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_239 = {
  key: 11,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_240 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_241 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_242 = { key: 0 }
const _hoisted_243 = { class: "mx-0 px-0 col-lg-9" }
const _hoisted_244 = { class: "row" }
const _hoisted_245 = { class: "col-lg-3" }
const _hoisted_246 = { class: "input-group" }
const _hoisted_247 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    for: "select-birthday",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_248 = { class: "col-lg-1 py-2 py-lg-0 d-flex align-items-center justify-content-lg-center h-38" }
const _hoisted_249 = { class: "col-lg-3" }
const _hoisted_250 = { class: "input-group" }
const _hoisted_251 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    for: "select-birthday",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_252 = {
  key: 12,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_253 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_254 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_255 = { key: 0 }
const _hoisted_256 = { class: "row mx-0 px-0 col-lg-4" }
const _hoisted_257 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_258 = ["placeholder"]
const _hoisted_259 = {
  key: 13,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_260 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_261 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_262 = { key: 0 }
const _hoisted_263 = { class: "row mx-0 px-0 col-lg-4" }
const _hoisted_264 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_265 = {
  key: 14,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_266 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_267 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_268 = { key: 0 }
const _hoisted_269 = { class: "mx-0 px-0 col-lg-4 d-flex justify-content-between" }
const _hoisted_270 = { class: "flex-basic-80 mx-lg-0 mx-2 mb-3 mb-lg-0" }
const _hoisted_271 = ["placeholder"]
const _hoisted_272 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_273 = { class: "mx-0 px-0 col-lg-4 d-flex justify-content-between" }
const _hoisted_274 = { class: "flex-basic-80 mx-lg-0 mx-2 mb-3 mb-lg-0" }
const _hoisted_275 = ["placeholder"]
const _hoisted_276 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_277 = {
  key: 15,
  class: "fw-bold mb-4 fs-6 py-2 px-2"
}
const _hoisted_278 = {
  key: 16,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_279 = { class: "w-max-content col-lg-2 col-form-label word-wrapper" }
const _hoisted_280 = { key: 0 }
const _hoisted_281 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_282 = { key: 0 }
const _hoisted_283 = {
  key: 0,
  class: "row mx-0 px-0 col-lg-4"
}
const _hoisted_284 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_285 = ["placeholder"]
const _hoisted_286 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_287 = {
  key: 1,
  class: "row mx-0 px-0 col-lg-4"
}
const _hoisted_288 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_289 = { value: "" }
const _hoisted_290 = ["value"]
const _hoisted_291 = {
  key: 2,
  class: "row mx-0 px-0 col-lg-9"
}
const _hoisted_292 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_293 = { class: "row w-100" }
const _hoisted_294 = { class: "d-flex height-fit-content" }
const _hoisted_295 = ["value"]
const _hoisted_296 = { class: "label-option-multi" }
const _hoisted_297 = {
  key: 17,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_298 = { class: "w-max-content col-lg-2 col-form-label word-wrapper" }
const _hoisted_299 = { key: 0 }
const _hoisted_300 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_301 = { key: 0 }
const _hoisted_302 = {
  key: 0,
  class: "row mx-0 px-0 col-lg-4"
}
const _hoisted_303 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_304 = ["placeholder"]
const _hoisted_305 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_306 = {
  key: 1,
  class: "row mx-0 px-0 col-lg-4"
}
const _hoisted_307 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_308 = { value: "" }
const _hoisted_309 = ["value"]
const _hoisted_310 = {
  key: 2,
  class: "row mx-0 px-0 col-lg-9"
}
const _hoisted_311 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_312 = { class: "row w-100" }
const _hoisted_313 = { class: "d-flex height-fit-content" }
const _hoisted_314 = ["value"]
const _hoisted_315 = { class: "label-option-multi" }
const _hoisted_316 = {
  key: 18,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_317 = { class: "w-max-content col-lg-2 col-form-label word-wrapper" }
const _hoisted_318 = { key: 0 }
const _hoisted_319 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_320 = { key: 0 }
const _hoisted_321 = {
  key: 0,
  class: "row mx-0 px-0 col-lg-4"
}
const _hoisted_322 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_323 = ["placeholder"]
const _hoisted_324 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_325 = {
  key: 1,
  class: "row mx-0 px-0 col-lg-4"
}
const _hoisted_326 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_327 = { value: "" }
const _hoisted_328 = ["value"]
const _hoisted_329 = {
  key: 2,
  class: "row mx-0 px-0 col-lg-9"
}
const _hoisted_330 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_331 = { class: "row w-100" }
const _hoisted_332 = { class: "d-flex height-fit-content" }
const _hoisted_333 = ["value"]
const _hoisted_334 = { class: "label-option-multi" }
const _hoisted_335 = {
  key: 19,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_336 = { class: "w-max-content col-lg-2 col-form-label word-wrapper" }
const _hoisted_337 = { key: 0 }
const _hoisted_338 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_339 = { key: 0 }
const _hoisted_340 = {
  key: 0,
  class: "row mx-0 px-0 col-lg-4"
}
const _hoisted_341 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_342 = ["placeholder"]
const _hoisted_343 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_344 = {
  key: 1,
  class: "row mx-0 px-0 col-lg-4"
}
const _hoisted_345 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_346 = { value: "" }
const _hoisted_347 = ["value"]
const _hoisted_348 = {
  key: 2,
  class: "row mx-0 px-0 col-lg-9"
}
const _hoisted_349 = { class: "col-12 px-2 px-lg-0" }
const _hoisted_350 = { class: "row w-100" }
const _hoisted_351 = { class: "d-flex height-fit-content" }
const _hoisted_352 = ["value"]
const _hoisted_353 = { class: "label-option-multi" }
const _hoisted_354 = {
  key: 20,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_355 = { class: "w-max-content col-lg-2 col-form-label word-wrapper" }
const _hoisted_356 = { key: 0 }
const _hoisted_357 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_358 = { key: 0 }
const _hoisted_359 = {
  key: 0,
  class: "row mx-0 px-0 col-lg-4"
}
const _hoisted_360 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_361 = ["placeholder"]
const _hoisted_362 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_363 = {
  key: 1,
  class: "row mx-0 px-0 col-lg-4"
}
const _hoisted_364 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_365 = { value: "" }
const _hoisted_366 = ["value"]
const _hoisted_367 = {
  key: 2,
  class: "row mx-0 px-0 col-lg-9"
}
const _hoisted_368 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_369 = { class: "row w-100" }
const _hoisted_370 = { class: "d-flex height-fit-content" }
const _hoisted_371 = ["value"]
const _hoisted_372 = { class: "label-option-multi" }
const _hoisted_373 = { class: "bg-white shadow rounded-4 p-2 p-lg-5 mb-3 mb-lg-5" }
const _hoisted_374 = { class: "fw-bold text-center mb-3 mb-lg-5 fs-6" }
const _hoisted_375 = { class: "text-break while-spaces term-of-use" }
const _hoisted_376 = { class: "checkbox-wrapper d-flex justify-content-center align-items-center px-2" }
const _hoisted_377 = {
  for: "consent_of_yelloop",
  class: "mt-1 ms-2"
}
const _hoisted_378 = {
  key: 0,
  class: "text-danger text-center"
}
const _hoisted_379 = { class: "bg-white shadow rounded-4 p-2 p-lg-5" }
const _hoisted_380 = { class: "fw-bold text-center mb-3 mb-lg-5 fs-6" }
const _hoisted_381 = { class: "text-break while-spaces term-of-use" }
const _hoisted_382 = { class: "checkbox-wrapper d-flex justify-content-center align-items-center px-2" }
const _hoisted_383 = {
  for: "consent_of_community",
  class: "mt-1 ms-2"
}
const _hoisted_384 = {
  key: 0,
  class: "text-danger text-center"
}
const _hoisted_385 = { class: "d-flex justify-content-center my-3 my-lg-5" }

import Status from '@/components/status/index.vue'
import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { ID } from './language/screenId'
import { useStore } from 'vuex'
import { getBirthdayConfig } from '@/constants/datepicker'
import { configYM } from '@/constants/datepicker'
import { getMessage } from '@/constants/messageCode'
import flatPickr from 'vue-flatpickr-component'
import { ref, computed, watchEffect, onMounted, nextTick, watch, toRaw } from 'vue'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import { REGISTER_STORE } from '@/store/constants'
import { DEFAULT_MIN_LENGTH, DEFAULT_MAX_JP_TEXT, MIN_LENGTH_EMAIL, MAX_LENGTH_EMAIL } from '@/constants/number'
import { useRoute, useRouter } from 'vue-router'
import useVuelidate from '@vuelidate/core'
import { required, requiredIf, maxLength, minLength, email, sameAs, numeric } from '@vuelidate/validators'
import { customMaxLength, customMaxLengthAlumni, parseJsonData, scrollToErrors, purifyContent } from '@/utils'
import { PASSWORD_REGEX, SPECIAL_WORDS, REGEX_EMOJI, PASSWORD_FORMAT_REGEX } from '@/constants/regex'
import ErrorMessage from '@/components/error-message/index.vue'
import TargetTag from '@/components/target-tag/index.vue'
import dayjs from 'dayjs'
import registerService from '@/services/register-alumnus.service'
import { debounce, isEmpty } from 'lodash'
import commonService from '@/services/common.service'
import { ROOT_STORE } from '@/store/constants'

import 'vue-toastification/dist/index.css'
import { useToast } from 'vue-toastification'
import ErrorToast from '@/components/toast-error/invited.vue'

import { apiUrlSubpath, PATH, PREFECTURES } from '@/constants/index'
import { ALUMNI_QUESTION_TYPE } from '@/constants/common'
import { AuthenMethodTypes } from '@/store/modules/register-alumnus'
import { useCountdown } from '@/use/useCountdown'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isSameOrBefore = require('dayjs/plugin/isSameOrBefore')
const isSameOrAfter = require('dayjs/plugin/isSameOrAfter')

dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)
const indexJob = ref(0)
const subJob = ref([])
const route = useRoute()
const router = useRouter()
const invitedCodeNotFound = ref<boolean | undefined>(undefined)
const disableBtn = ref(true)
const listPrefectures = ref(PREFECTURES.slice(0, -1))
const lastChoosenPrefecture = ref('')
const store = useStore()
const emailSame = ref<string>('')
const invalidUrlError = ref<string>('')
const communityRequiredData = computed(() => store.getters[REGISTER_STORE.GETTERS.COMMUNITY_REQUIRED_COLUMNS])
const registerAlumnusData = computed(() => store.getters[REGISTER_STORE.GETTERS.REGISTER_VALUE])
const inviteData = computed(() => store.getters[REGISTER_STORE.GETTERS.INVITE])
const termsYelloop = computed(() => store.getters[REGISTER_STORE.GETTERS.TERMS_SERVICE_YELLOOP])
const termsCommunity = computed(() => store.getters[REGISTER_STORE.GETTERS.TERMS_SERVICE_COMMUNITY])
const listJobs = computed(() => store.getters[REGISTER_STORE.GETTERS.LIST_JOBS])
const formData = ref(registerAlumnusData)
const isMobile = computed(() => store.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])
const validPostAlum = computed(() => store.getters[REGISTER_STORE.GETTERS.GET_VALIDATE_POST_ALUMNUS])
const fullPhoneNumber = computed(() => {
  const p1 = formData.value.phone_number_1 || '000'
  const p2 = formData.value.phone_number_2 || '0000'
  const p3 = formData.value.phone_number_3 || '0000'
  return `${p1}-${p2}-${p3}`
})
const toast = useToast()
const { timeLeft, showCountTime, startCountdown } = useCountdown(`countdownEndTimeSendTest_${route.meta.screenId}`)
const submittingButton = ref<boolean>(false)

const additional_information_checkbox = ref({
  additional_information_checkbox1:
    communityRequiredData.value.additional_information_1_setting?.type === ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE
      ? parseJsonData(registerAlumnusData.value.additional_information_1) || []
      : [],
  additional_information_checkbox2:
    communityRequiredData.value.additional_information_2_setting?.type === ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE
      ? parseJsonData(registerAlumnusData.value.additional_information_2) || []
      : [],
  additional_information_checkbox3:
    communityRequiredData.value.additional_information_3_setting?.type === ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE
      ? parseJsonData(registerAlumnusData.value.additional_information_3) || []
      : [],
  additional_information_checkbox4:
    communityRequiredData.value.additional_information_4_setting?.type === ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE
      ? parseJsonData(registerAlumnusData.value.additional_information_4) || []
      : [],
  additional_information_checkbox5:
    communityRequiredData.value.additional_information_5_setting?.type === ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE
      ? parseJsonData(registerAlumnusData.value.additional_information_5) || []
      : [],
  additional_information_select1:
    communityRequiredData.value.additional_information_1_setting?.type === ALUMNI_QUESTION_TYPE.SINGLE_CHOICE ? registerAlumnusData.value.additional_information_1 : '',
  additional_information_select2:
    communityRequiredData.value.additional_information_2_setting?.type === ALUMNI_QUESTION_TYPE.SINGLE_CHOICE ? registerAlumnusData.value.additional_information_2 : '',
  additional_information_select3:
    communityRequiredData.value.additional_information_3_setting?.type === ALUMNI_QUESTION_TYPE.SINGLE_CHOICE ? registerAlumnusData.value.additional_information_3 : '',
  additional_information_select4:
    communityRequiredData.value.additional_information_4_setting?.type === ALUMNI_QUESTION_TYPE.SINGLE_CHOICE ? registerAlumnusData.value.additional_information_4 : '',
  additional_information_select5:
    communityRequiredData.value.additional_information_5_setting?.type === ALUMNI_QUESTION_TYPE.SINGLE_CHOICE ? registerAlumnusData.value.additional_information_5 : '',
})

onMounted(async () => {
  try {
    await store.dispatch(REGISTER_STORE.ACTIONS.SET_INVITE, route.query?.invited_code)
    if (inviteData.value?.community_id) {
      store.dispatch(REGISTER_STORE.ACTIONS.SET_COMMUNITY_REQUIRED_COLUMNS, inviteData.value?.community_id)
      store.dispatch(REGISTER_STORE.ACTIONS.SET_TERMS_SERVICE_COMMUNITY, inviteData.value?.community_id)
      invitedCodeNotFound.value = false
    } else {
      invitedCodeNotFound.value = true
    }
  } catch (error) {
    console.log(error)
  }

  store.dispatch(REGISTER_STORE.ACTIONS.SET_TERMS_SERVICE_YELLOOP, 'alumni')
  store.dispatch(REGISTER_STORE.ACTIONS.SET_LIST_JOBS)

  if (formData.value.zipcode_judgment) {
    listPrefectures.value = PREFECTURES.slice(-1)
    formData.value.address_1 = 48
  }
})

const fullContent = ref<boolean>(false)
const SeeMore = () => {
  fullContent.value = true
}

const supplementaryInformation = ref<HTMLElement>()
const seeMoreBtn = ref<string>(0)

watch(
  () => communityRequiredData,
  async () => {
    await nextTick()
    seeMoreBtn.value = supplementaryInformation.value?.offsetHeight
  },
  {
    deep: true,
    immediate: true,
  }
)

watchEffect(() => {
  localStorage.removeItem('checkSubmit')
  if (listJobs.value?.length > 0) subJob.value = listJobs.value?.find((e: any) => e.id === formData.value?.job_type_parent_id)?.child
})

watch(
  () => formData.value.zipcode_judgment,
  (value) => {
    if (value) {
      listPrefectures.value = PREFECTURES.slice(-1)
      lastChoosenPrefecture.value = formData.value?.address_1
      formData.value.address_1 = 48
    } else {
      listPrefectures.value = PREFECTURES.slice(0, -1)
      formData.value.address_1 = lastChoosenPrefecture.value !== 48 ? lastChoosenPrefecture.value : ''
    }
  }
)

const rulesCheckbox = computed(() => {
  return {
    //If additional_information_1 === 1 :required / =2:optional / =0: not show
    //If additional_information_1 === 1 :required & additional_information_1_setting?.type !==0 (! textinput)
    additional_information_checkbox1: {
      requiredSelect: requiredIf(
        communityRequiredData.value.additional_information_1 === 1 && communityRequiredData.value.additional_information_1_setting?.type == ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE
      ),
      // requiredSelect: function (value) {
      //   if (value) return true
      // },
    },
    additional_information_checkbox2: {
      requiredSelect: requiredIf(
        communityRequiredData.value.additional_information_2 === 1 && communityRequiredData.value.additional_information_2_setting?.type == ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE
      ),
      // requiredSelect: function (value) {
      //   if (value) return true
      // },
    },
    additional_information_checkbox3: {
      requiredSelect: requiredIf(
        communityRequiredData.value.additional_information_3 === 1 && communityRequiredData.value.additional_information_3_setting?.type == ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE
      ),
      // requiredSelect: function (value) {
      //   if (value) return true
      // },
    },
    additional_information_checkbox4: {
      requiredSelect: requiredIf(
        communityRequiredData.value.additional_information_4 === 1 && communityRequiredData.value.additional_information_4_setting?.type == ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE
      ),
      // requiredSelect: function (value) {
      //   if (value) return true
      // },
    },
    additional_information_checkbox5: {
      requiredSelect: requiredIf(
        communityRequiredData.value.additional_information_5 === 1 && communityRequiredData.value.additional_information_5_setting?.type == ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE
      ),
      // requiredSelect: function (value) {
      //   if (value) return true
      // },
    },
    additional_information_select1: {
      requiredSelect: requiredIf(
        communityRequiredData.value.additional_information_1 === 1 && communityRequiredData.value.additional_information_1_setting?.type == ALUMNI_QUESTION_TYPE.SINGLE_CHOICE
      ),
      // requiredSelect: function (value) {
      //   if (value && value !== '') return true
      // },
    },
    additional_information_select2: {
      requiredSelect: requiredIf(
        communityRequiredData.value.additional_information_2 === 1 && communityRequiredData.value.additional_information_2_setting?.type == ALUMNI_QUESTION_TYPE.SINGLE_CHOICE
      ),
      // requiredSelect: function (value) {
      //   if (value && value !== '') return true
      // },
    },
    additional_information_select3: {
      requiredSelect: requiredIf(
        communityRequiredData.value.additional_information_3 === 1 && communityRequiredData.value.additional_information_3_setting?.type == ALUMNI_QUESTION_TYPE.SINGLE_CHOICE
      ),
      // requiredSelect: function (value) {
      //   if (value && value !== '') return true
      // },
    },
    additional_information_select4: {
      requiredSelect: requiredIf(
        communityRequiredData.value.additional_information_4 === 1 && communityRequiredData.value.additional_information_4_setting?.type == ALUMNI_QUESTION_TYPE.SINGLE_CHOICE
      ),
      // requiredSelect: function (value) {
      //   if (value && value !== '') return true
      // },
    },
    additional_information_select5: {
      requiredSelect: requiredIf(
        communityRequiredData.value.additional_information_5 === 1 && communityRequiredData.value.additional_information_5_setting?.type == ALUMNI_QUESTION_TYPE.SINGLE_CHOICE
      ),
      // requiredSelect: function (value) {
      //   if (value && value !== '') return true
      // },
    },
  }
})

const rules = computed(() => {
  return {
    family_name: {
      required,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, DEFAULT_MAX_JP_TEXT),
      emoji: function (value) {
        return REGEX_EMOJI.test(value)
      },
    },
    given_name: {
      required,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, DEFAULT_MAX_JP_TEXT),
      emoji: function (value) {
        return REGEX_EMOJI.test(value)
      },
    },
    family_name_kana: {
      required,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, DEFAULT_MAX_JP_TEXT),
      fullSizeKatakana: function (value) {
        return /^([ァ-ヶ]|ー)+$/.test(value)
      },
    },
    given_name_kana: {
      required,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, DEFAULT_MAX_JP_TEXT),
      fullSizeKatakana: function (value) {
        return /^([ァ-ヶ]|ー)+$/.test(value)
      },
    },
    display_name: {
      required,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, DEFAULT_MAX_JP_TEXT),
      emoji: function (value) {
        return REGEX_EMOJI.test(value)
      },
    },
    email: {
      required,
      minLength: minLength(MIN_LENGTH_EMAIL),
      maxLength: (value: string) => customMaxLength(value, MAX_LENGTH_EMAIL),
      email,
    },
    birthday: {
      required,
      maxDate: function (value) {
        const date = dayjs(value).format('YYYY-MM-DD')
        if (!dayjs().isBefore(dayjs(date))) return true
      },
      minDate: function (value) {
        if (dayjs(value).format('YYYY-MM-DD') >= dayjs('01/01/1900').format('YYYY-MM-DD')) return true
      },
    },
    zipcode_1: {
      required: requiredIf(!formData.value.zipcode_judgment),
      numeric: function (value) {
        if (formData.value.zipcode_judgment) {
          return true
        }
        return !isNaN(parseFloat(value)) && isFinite(value)
      },
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: function (value) {
        if (formData.value.zipcode_judgment) {
          return true
        }
        return customMaxLength(value, 3)
      },
    },
    zipcode_2: {
      required: requiredIf(!formData.value.zipcode_judgment),
      numeric: function (value) {
        if (formData.value.zipcode_judgment) {
          return true
        }
        return !isNaN(parseFloat(value)) && isFinite(value)
      },
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: function (value) {
        if (formData.value.zipcode_judgment) {
          return true
        }
        return customMaxLength(value, 4)
      },
    },
    zipcode_foreign: {
      required: requiredIf(formData.value.zipcode_judgment),
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: function (value) {
        if (!formData.value.zipcode_judgment) {
          return true
        }
        return customMaxLength(value, 30)
      },
    },
    address_1: {
      requiredSelect: function (value) {
        if (value && value != 0) return true
      },
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: maxLength(2),
    },
    address_2: {
      required,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: maxLength(1000),
      emoji: function (value) {
        return REGEX_EMOJI.test(value)
      },
    },
    phone_number_1: {
      required,
      numeric,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: maxLength(5),
    },
    phone_number_2: {
      required,
      numeric,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: maxLength(4),
    },
    phone_number_3: {
      required,
      numeric,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: maxLength(4),
    },
    institution: {
      required,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, 100),
      emoji: function (value) {
        return REGEX_EMOJI.test(value)
      },
    },
    job_type_parent_id: {
      requiredSelect: function (value) {
        if (value) return true
      },
    },
    job_type_child_id: {
      requiredSelect: function (value) {
        if (value) return true
      },
    },
    enrollment_start_period: {
      required,
      maxDate: function (value) {
        const date = dayjs(value).format('YYYY-MM-DD')
        if (!dayjs().isBefore(dayjs(date))) return true
      },
      minDate: function (value) {
        if (dayjs(value).format('YYYY-MM-DD') >= dayjs('01/01/1900').format('YYYY-MM-DD')) return true
      },
    },
    password: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(128),
      //ngWord,
      containsSpecialWords: function (value) {
        let count = 0
        SPECIAL_WORDS.forEach((e) => {
          if (value === e) count++
        })
        if (count === 0) return true
      },
      emoji: function (value) {
        return REGEX_EMOJI.test(value)
      },
      containsTypeSpecialCharacter: function (value) {
        let count = 0
        ;[...value].forEach((e) => {
          if (PASSWORD_FORMAT_REGEX.test(e)) count++
        })
        if (count === value.length) return true
      },
      containsType: function (value) {
        return PASSWORD_REGEX.test(value)
      },
    },

    confirmPassword: {
      required,
      maxLength: maxLength(128),
      minLength: minLength(8),
      sameAsPassword: sameAs(formData.value.password),
    },

    corporation_organization_name: {
      required: requiredIf(communityRequiredData.value.corporation_organization_name === 1),
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, 100),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },

    corporation_department_name: {
      required: requiredIf(communityRequiredData.value.corporation_department_name === 1),
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, 100),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },

    corporation_start_period: {
      required: requiredIf(communityRequiredData.value.corporation_start_period === 1 && communityRequiredData.value.corporation_end_period === 1),
      maxDate: function (value) {
        const date = dayjs(value).format('YYYY-MM-DD')
        if (!dayjs().isBefore(dayjs(date))) return true
      },
      minDate: function (value) {
        if (dayjs(value).format('YYYY-MM-DD') >= dayjs('01/01/1900').format('YYYY-MM-DD')) return true
      },
    },

    corporation_end_period: {
      required: requiredIf(communityRequiredData.value.corporation_start_period === 1 && communityRequiredData.value.corporation_end_period === 1),
      maxDate: function (value) {
        const date = dayjs(value).format('YYYY-MM-DD')
        if (!dayjs().isBefore(dayjs(date))) return true
      },
      minDate: function (value) {
        if (dayjs(value).format('YYYY-MM-DD') >= dayjs('01/01/1900').format('YYYY-MM-DD')) return true
      },
      afterStartDate: function (value) {
        if (
          dayjs(formData.value.corporation_start_period).format('YYYY/MM/DD') !== 'Invalid Date' &&
          dayjs(formData.value.corporation_start_period).format('YYYY/MM/DD') !== dayjs(value).format('YYYY/MM/DD')
        ) {
          return dayjs(value).isSameOrAfter(dayjs(formData.value.corporation_start_period))
        } else {
          return true
        }
      },
    },

    corporation_employee_id: {
      required: requiredIf(communityRequiredData.value.corporation_employee_id === 1),
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, 20),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },

    corporation_email: {
      required: requiredIf(communityRequiredData.value.corporation_email === 1),
      minLength: minLength(MIN_LENGTH_EMAIL),
      maxLength: (value: string) => customMaxLength(value, MAX_LENGTH_EMAIL),
      email,
    },

    corporation_family_name: {
      required: requiredIf(communityRequiredData.value.corporation_family_name === 1),
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, 20),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },

    corporation_given_name: {
      required: requiredIf(communityRequiredData.value.corporation_given_name === 1),
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, 20),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },

    school_organization_name: {
      required: requiredIf(communityRequiredData.value.school_organization_name === 1),
      maxLength: (value: string) => customMaxLength(value, 100),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },

    school_faclty_name: {
      required: requiredIf(communityRequiredData.value.school_faclty_name === 1),
      maxLength: (value: string) => customMaxLength(value, 100),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },

    school_department_name: {
      required: requiredIf(communityRequiredData.value.school_department_name === 1),
      maxLength: (value: string) => customMaxLength(value, 100),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },

    school_start_period: {
      required: requiredIf(communityRequiredData.value.school_start_period === 1 && communityRequiredData.value.school_end_period === 1),
      maxDate: function (value) {
        const date = dayjs(value).format('YYYY-MM-DD')
        if (!dayjs().isBefore(dayjs(date))) return true
      },
      minDate: function (value) {
        if (dayjs(value).format('YYYY-MM-DD') >= dayjs('01/01/1900').format('YYYY-MM-DD')) return true
      },
    },

    school_end_period: {
      required: requiredIf(communityRequiredData.value.school_start_period === 1 && communityRequiredData.value.school_end_period === 1),
      maxDate: function (value) {
        const date = dayjs(value).format('YYYY-MM-DD')
        if (!dayjs().isBefore(dayjs(date))) return true
      },
      minDate: function (value) {
        if (dayjs(value).format('YYYY-MM-DD') >= dayjs('01/01/1900').format('YYYY-MM-DD')) return true
      },
      afterStartDate: function (value) {
        if (
          dayjs(formData.value.school_start_period).format('YYYY/MM/DD') !== 'Invalid Date' &&
          dayjs(formData.value.school_start_period).format('YYYY/MM/DD') !== dayjs(value).format('YYYY/MM/DD')
        ) {
          return dayjs(value).isSameOrAfter(dayjs(formData.value.school_start_period))
        } else {
          return true
        }
      },
    },

    school_student_id: {
      required: requiredIf(communityRequiredData.value.school_student_id === 1),
      maxLength: (value: string) => customMaxLength(value, 20),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },

    school_email: {
      required: requiredIf(communityRequiredData.value.school_email === 1),
      minLength: minLength(MIN_LENGTH_EMAIL),
      maxLength: (value: string) => customMaxLength(value, MAX_LENGTH_EMAIL),
      email,
    },

    school_family_name: {
      required: requiredIf(communityRequiredData.value.school_family_name === 1 && communityRequiredData.value.school_given_name === 1),
      maxLength: (value: string) => customMaxLength(value, 20),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },

    school_given_name: {
      required: requiredIf(communityRequiredData.value.school_family_name === 1 && communityRequiredData.value.school_given_name === 1),
      maxLength: (value: string) => customMaxLength(value, 20),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },
    additional_information_1: {
      required: requiredIf(
        communityRequiredData.value.additional_information_1 === 1 && communityRequiredData.value.additional_information_1_setting?.type === ALUMNI_QUESTION_TYPE.FREE_TEXT
      ),
      maxLength: (value: string) => customMaxLengthAlumni(communityRequiredData.value.additional_information_1_setting?.type, value, 100),
      emoji: function (value) {
        if (communityRequiredData.value.additional_information_1_setting?.type !== ALUMNI_QUESTION_TYPE.FREE_TEXT) {
          return true
        }
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },
    additional_information_2: {
      required: requiredIf(
        communityRequiredData.value.additional_information_2 === 1 && communityRequiredData.value.additional_information_2_setting?.type === ALUMNI_QUESTION_TYPE.FREE_TEXT
      ),
      maxLength: (value: string) => customMaxLengthAlumni(communityRequiredData.value.additional_information_2_setting?.type, value, 100),
      emoji: function (value) {
        if (communityRequiredData.value.additional_information_2_setting?.type !== ALUMNI_QUESTION_TYPE.FREE_TEXT) {
          return true
        }
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },
    additional_information_3: {
      required: requiredIf(
        communityRequiredData.value.additional_information_3 === 1 && communityRequiredData.value.additional_information_3_setting?.type === ALUMNI_QUESTION_TYPE.FREE_TEXT
      ),
      maxLength: (value: string) => customMaxLengthAlumni(communityRequiredData.value.additional_information_3_setting?.type, value, 100),
      emoji: function (value) {
        if (communityRequiredData.value.additional_information_3_setting?.type !== ALUMNI_QUESTION_TYPE.FREE_TEXT) {
          return true
        }
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },
    additional_information_4: {
      required: requiredIf(
        communityRequiredData.value.additional_information_4 === 1 && communityRequiredData.value.additional_information_4_setting?.type === ALUMNI_QUESTION_TYPE.FREE_TEXT
      ),
      maxLength: (value: string) => customMaxLengthAlumni(communityRequiredData.value.additional_information_4_setting?.type, value, 100),
      emoji: function (value) {
        if (communityRequiredData.value.additional_information_4_setting?.type !== ALUMNI_QUESTION_TYPE.FREE_TEXT) {
          return true
        }
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },
    additional_information_5: {
      required: requiredIf(
        communityRequiredData.value.additional_information_5 === 1 && communityRequiredData.value.additional_information_5_setting?.type === ALUMNI_QUESTION_TYPE.FREE_TEXT
      ),
      maxLength: (value: string) => customMaxLengthAlumni(communityRequiredData.value.additional_information_5_setting?.type, value, 100),
      emoji: function (value) {
        if (communityRequiredData.value.additional_information_5_setting?.type !== ALUMNI_QUESTION_TYPE.FREE_TEXT) {
          return true
        }
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },
    authentication_method: {
      required,
    },
  }
})

watchEffect(() => {
  if (formData.value.consent_of_yelloop && formData.value.consent_of_community) {
    disableBtn.value = false
  } else {
    disableBtn.value = true
  }
})
const v$ = useVuelidate(rules, formData)
const vCheckbox$ = useVuelidate(rulesCheckbox, additional_information_checkbox)
// console.log('1837 formData ', formData.value)
// console.log('1838 additional_information_checkbox ', additional_information_checkbox.value)

const checkSubmit = ref(false)

const getAdditionalValue = (index) => {
  if (communityRequiredData.value[`additional_information_${index}`] === 0) return ''
  if (communityRequiredData.value[`additional_information_${index}_setting`]?.type === ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE) {
    if (!isEmpty(additional_information_checkbox.value[`additional_information_checkbox${index}`])) {
      var sort_result = []
      additional_information_checkbox.value[`additional_information_checkbox${index}`].forEach((item) => {
        const index = parseInt(item.substring(item.lastIndexOf('_') + 1), 10)
        sort_result[index] = item
      })
      sort_result = Object.values(sort_result).filter((value) => value !== null)
      return JSON.stringify(sort_result)
    }
    return JSON.stringify(additional_information_checkbox.value[`additional_information_checkbox${index}`])
  } else {
    return communityRequiredData.value[`additional_information_${index}_setting`]?.type === ALUMNI_QUESTION_TYPE.SINGLE_CHOICE
      ? additional_information_checkbox.value[`additional_information_select${index}`]
      : formData.value[`additional_information_${index}`]
  }
}

const formatDataSendToVerify = () => {
  let formDataNow = toRaw(formData.value)
  Array.from({ length: 5 }, (_, i) => i + 1).forEach((i) => {
    formDataNow[`additional_information_${i}`] = getAdditionalValue(i)
  })

  return formDataNow
}

const onSubmit = async (): Promise<void> => {
  v$.value.$touch()
  vCheckbox$.value.$touch()

  checkSubmit.value = true

  const isCheckedNGItems: Array<{ value: boolean }> = [
    isCheckedNGFamilyName,
    isCheckedNGGivenName,
    isCheckedNGFamilyNameKana,
    isCheckedNGGivenNameKana,
    isCheckedNGDisplayName,
    isCheckedNGInstitution,
    isCheckedNGCorporationOrganizationName,
    isCheckedNGCorporationDepartmentName,
    isCheckedNGCorporationFamilyName,
    isCheckedNGCorporationGivenName,
    isCheckedNGSchoolOrganizationName,
    isCheckedNGSchoolFacltyName,
    isCheckedNGSchoolDepartmentName,
    isCheckedNGSchoolFamilyName,
    isCheckedNGSchoolGivenName,
    isCheckedNGAdditionalInformation1,
    isCheckedNGAdditionalInformation2,
    isCheckedNGAdditionalInformation3,
    isCheckedNGAdditionalInformation4,
    isCheckedNGAdditionalInformation5,
  ]
  isCheckedNGItems.forEach((checkedNGItem) => (checkedNGItem.value = false))
  await Promise.all([
    checkNGFamilyName(),
    checkNGGivenName(),
    checkNGFamilyNameKana(),
    checkNGGivenNameKana(),
    checkNGDisplayName(),
    checkNGInstitution(),
    checkNGCorporationOrganizationName(),
    checkNGCorporationDepartmentName(),
    checkNGCorporationFamilyName(),
    checkNGCorporationGivenName(),
    checkNGSchoolOrganizationName(),
    checkNGSchoolFacltyName(),
    checkNGSchoolDepartmentName(),
    checkNGSchoolFamilyName(),
    checkNGSchoolGivenName(),
    checkNGAdditionalInformation1(),
    checkNGAdditionalInformation2(),
    checkNGAdditionalInformation3(),
    checkNGAdditionalInformation4(),
    checkNGAdditionalInformation5(),
  ])
  while (!isCheckedNGItems.every((checkedNGItem) => checkedNGItem.value)) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }

  if (
    v$.value.$invalid ||
    vCheckbox$.value.$invalid ||
    ngKeyFamilyName.value ||
    ngKeyGivenName.value ||
    ngKeyFamilyNameKana.value ||
    ngKeyGivenNameKana.value ||
    ngKeyDisplayName.value ||
    ngKeyInstitution.value ||
    ngKeyCorporationOrganizationName.value ||
    ngKeyCorporationDepartmentName.value ||
    ngKeyCorporationFamilyName.value ||
    ngKeyCorporationGivenName.value ||
    ngKeySchoolOrganizationName.value ||
    ngKeySchoolFacltyName.value ||
    ngKeySchoolDepartmentName.value ||
    ngKeySchoolFamilyName.value ||
    ngKeySchoolGivenName.value ||
    ngKeyAdditionalInformation1.value ||
    ngKeyAdditionalInformation2.value ||
    ngKeyAdditionalInformation3.value ||
    ngKeyAdditionalInformation4.value ||
    ngKeyAdditionalInformation5.value
  ) {
    nextTick(() => {
      scrollToErrors()
    })
    return
  }
  try {
    const response = await registerService.checkMailSame(inviteData.value?.community_id, { email: formData.value.email, invited_code: route.query?.invited_code })
    if (response?.status === 200) {
      if (formData.value.consent_of_yelloop && formData.value.consent_of_community) {
        clearUnrequiredInfoAlumnus()
        const dataVerify = formatDataSendToVerify()

        store.dispatch(REGISTER_STORE.ACTIONS.SET_REGISTER_VALUE, dataVerify)
        router.push({ path: '/alumni/register_alumnus_confirm', query: { invited_code: route.query?.invited_code } })
        window.scroll(0, 0)
        localStorage.setItem('checkConfirm', true)
      }
    } else if (response?.status !== 200) {
      if (response?.response?.data?.data[0]?.message_code === 'ERROR_INVALID_PARAMS') {
        toast.error({
          component: ErrorToast,
        })
      } else if (response?.response?.data?.data[0]?.message_code === 'INVALID_URL_ERROR') {
        invalidUrlError.value = response?.response?.data?.data[0]?.message_code
      } else {
        emailSame.value = response?.response?.data?.data[0]?.message_code
        nextTick(() => {
          scrollToErrors('.email-same')
        })
      }
    } else {
      window.scroll(0, 0)
    }
  } catch (error) {
    console.log(error)
  }
}

const disableCorporation = ref(true)
const disableSchool = ref(true)
const disableInformation = ref(true)
watchEffect(() => {
  disableCorporation.value =
    communityRequiredData?.value.corporation_organization_name === 0 &&
    communityRequiredData?.value.corporation_department_name === 0 &&
    communityRequiredData?.value.corporation_email === 0 &&
    communityRequiredData?.value.corporation_employee_id === 0 &&
    communityRequiredData?.value.corporation_end_period === 0 &&
    communityRequiredData?.value.corporation_family_name === 0 &&
    communityRequiredData?.value.corporation_given_name === 0 &&
    communityRequiredData?.value.corporation_start_period === 0
  disableSchool.value =
    communityRequiredData?.value.school_organization_name === 0 &&
    communityRequiredData?.value.school_department_name === 0 &&
    communityRequiredData?.value.school_email === 0 &&
    communityRequiredData?.value.school_end_period === 0 &&
    communityRequiredData?.value.school_faclty_name === 0 &&
    communityRequiredData?.value.school_family_name === 0 &&
    communityRequiredData?.value.school_given_name === 0 &&
    communityRequiredData?.value.school_start_period === 0 &&
    communityRequiredData?.value.school_student_id === 0
  disableInformation.value =
    communityRequiredData?.value.additional_information_1 === 0 &&
    communityRequiredData?.value.additional_information_2 === 0 &&
    communityRequiredData?.value.additional_information_3 === 0 &&
    communityRequiredData?.value.additional_information_4 === 0 &&
    communityRequiredData?.value.additional_information_5 === 0
})

const placeholderDefault = translate('placeholder')
const selectChild = ref('')

const changeIndexJob = (index: number) => {
  indexJob.value = index
  // selectChild.value.size = 2
}
const changeEmail = () => {
  emailSame.value = ''
}

// 2022/10/04 CW-Phuong Fix for UAT Phase2#4577: SA20 (Ph2-R20221007)
watch(
  () => indexJob.value,
  () => {
    formData.value.job_type_child_id = ''
  }
)
const isCheckedNGFamilyName = { value: false }
const ngKeyFamilyName = ref<boolean>(false)
const checkNGFamilyName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.family_name.$model })
  ngKeyFamilyName.value = data.data?.data?.has_ngword
  isCheckedNGFamilyName.value = true
}, 200)

const isCheckedNGGivenName = { value: false }
const ngKeyGivenName = ref<boolean>(false)
const checkNGGivenName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.given_name.$model })
  ngKeyGivenName.value = data.data?.data?.has_ngword
  isCheckedNGGivenName.value = true
}, 200)

const isCheckedNGFamilyNameKana = { value: false }
const ngKeyFamilyNameKana = ref<boolean>(false)
const checkNGFamilyNameKana = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.family_name_kana.$model })
  ngKeyFamilyNameKana.value = data.data?.data?.has_ngword
  isCheckedNGFamilyNameKana.value = true
}, 200)

const isCheckedNGGivenNameKana = { value: false }
const ngKeyGivenNameKana = ref<boolean>(false)
const checkNGGivenNameKana = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.given_name_kana.$model })
  ngKeyGivenNameKana.value = data.data?.data?.has_ngword
  isCheckedNGGivenNameKana.value = true
}, 200)

const isCheckedNGDisplayName = { value: false }
const ngKeyDisplayName = ref<boolean>(false)
const checkNGDisplayName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.display_name.$model })
  ngKeyDisplayName.value = data.data?.data?.has_ngword
  isCheckedNGDisplayName.value = true
}, 200)

const isCheckedNGInstitution = { value: false }
const ngKeyInstitution = ref<boolean>(false)
const checkNGInstitution = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.institution.$model })
  ngKeyInstitution.value = data.data?.data?.has_ngword
  isCheckedNGInstitution.value = true
}, 200)

const isCheckedNGCorporationOrganizationName = { value: false }
const ngKeyCorporationOrganizationName = ref<boolean>(false)
const checkNGCorporationOrganizationName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.corporation_organization_name.$model })
  ngKeyCorporationOrganizationName.value = data.data?.data?.has_ngword
  isCheckedNGCorporationOrganizationName.value = true
}, 200)

const isCheckedNGCorporationDepartmentName = { value: false }
const ngKeyCorporationDepartmentName = ref<boolean>(false)
const checkNGCorporationDepartmentName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.corporation_department_name.$model })
  ngKeyCorporationDepartmentName.value = data.data?.data?.has_ngword
  isCheckedNGCorporationDepartmentName.value = true
}, 200)

const isCheckedNGCorporationFamilyName = { value: false }
const ngKeyCorporationFamilyName = ref<boolean>(false)
const checkNGCorporationFamilyName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.corporation_family_name.$model })
  ngKeyCorporationFamilyName.value = data.data?.data?.has_ngword
  isCheckedNGCorporationFamilyName.value = true
}, 200)

const isCheckedNGCorporationGivenName = { value: false }
const ngKeyCorporationGivenName = ref<boolean>(false)
const checkNGCorporationGivenName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.corporation_given_name.$model })
  ngKeyCorporationGivenName.value = data.data?.data?.has_ngword
  isCheckedNGCorporationGivenName.value = true
}, 200)

const isCheckedNGSchoolOrganizationName = { value: false }
const ngKeySchoolOrganizationName = ref<boolean>(false)
const checkNGSchoolOrganizationName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.school_organization_name.$model })
  ngKeySchoolOrganizationName.value = data.data?.data?.has_ngword
  isCheckedNGSchoolOrganizationName.value = true
}, 200)

const isCheckedNGSchoolFacltyName = { value: false }
const ngKeySchoolFacltyName = ref<boolean>(false)
const checkNGSchoolFacltyName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.school_faclty_name.$model })
  ngKeySchoolFacltyName.value = data.data?.data?.has_ngword
  isCheckedNGSchoolFacltyName.value = true
}, 200)

const isCheckedNGSchoolDepartmentName = { value: false }
const ngKeySchoolDepartmentName = ref<boolean>(false)
const checkNGSchoolDepartmentName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.school_department_name.$model })
  ngKeySchoolDepartmentName.value = data.data?.data?.has_ngword
  isCheckedNGSchoolDepartmentName.value = true
}, 200)

const isCheckedNGSchoolFamilyName = { value: false }
const ngKeySchoolFamilyName = ref<boolean>(false)
const checkNGSchoolFamilyName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.school_family_name.$model })
  ngKeySchoolFamilyName.value = data.data?.data?.has_ngword
  isCheckedNGSchoolFamilyName.value = true
}, 200)

const isCheckedNGSchoolGivenName = { value: false }
const ngKeySchoolGivenName = ref<boolean>(false)
const checkNGSchoolGivenName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.school_given_name.$model })
  ngKeySchoolGivenName.value = data.data?.data?.has_ngword
  isCheckedNGSchoolGivenName.value = true
}, 200)

const isCheckedNGAdditionalInformation1 = { value: false }
const ngKeyAdditionalInformation1 = ref<boolean>(false)
const checkNGAdditionalInformation1 = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.additional_information_1.$model })
  ngKeyAdditionalInformation1.value = data.data?.data?.has_ngword
  isCheckedNGAdditionalInformation1.value = true
}, 200)

const isCheckedNGAdditionalInformation2 = { value: false }
const ngKeyAdditionalInformation2 = ref<boolean>(false)
const checkNGAdditionalInformation2 = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.additional_information_2.$model })
  ngKeyAdditionalInformation2.value = data.data?.data?.has_ngword
  isCheckedNGAdditionalInformation2.value = true
}, 200)

const isCheckedNGAdditionalInformation3 = { value: false }
const ngKeyAdditionalInformation3 = ref<boolean>(false)
const checkNGAdditionalInformation3 = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.additional_information_3.$model })
  ngKeyAdditionalInformation3.value = data.data?.data?.has_ngword
  isCheckedNGAdditionalInformation3.value = true
}, 200)

const isCheckedNGAdditionalInformation4 = { value: false }
const ngKeyAdditionalInformation4 = ref<boolean>(false)
const checkNGAdditionalInformation4 = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.additional_information_4.$model })
  ngKeyAdditionalInformation4.value = data.data?.data?.has_ngword
  isCheckedNGAdditionalInformation4.value = true
}, 200)

const isCheckedNGAdditionalInformation5 = { value: false }
const ngKeyAdditionalInformation5 = ref<boolean>(false)
const checkNGAdditionalInformation5 = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.additional_information_5.$model })
  ngKeyAdditionalInformation5.value = data.data?.data?.has_ngword
  isCheckedNGAdditionalInformation5.value = true
}, 200)

const clearUnrequiredInfoAlumnus = () => {
  // Clear unrequired info alumnus fields
  Object.keys(formData.value).forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(communityRequiredData.value, key) && !communityRequiredData.value[key]) {
      formData.value[key] = null
    }
  })
}
const sendTestPhoneNumber = debounce(async () => {
  submittingButton.value = true
  const p1 = formData.value.phone_number_1 || '000'
  const p2 = formData.value.phone_number_2 || '0000'
  const p3 = formData.value.phone_number_3 || '0000'
  const phoneNumber = `${p1}${p2}${p3}`
  try {
    const data = await commonService.sendTestPhoneNumber({ phone_number: phoneNumber })
    if (data?.response?.status === 400) {
      scrollToErrors('#phone-number')
      toast.error({
        component: ErrorToast,
        props: {
          messageCode: 'バリデーションエラー',
        },
      })
      submittingButton.value = false
    } else if (data?.status !== 200) {
      toast.error({
        component: ErrorToast,
        props: {
          messageCode: 'リクエストエラーが発生しました。しばらく経ってからアクセスしてください。',
        },
      })
      submittingButton.value = false
    } else {
      startCountdown(30)
    }
  } catch (error) {
    toast.error({
      component: ErrorToast,
      props: {
        messageCode: 'リクエストエラーが発生しました。しばらく経ってからアクセスしてください。',
      },
    })
    submittingButton.value = false
  }
}, 200)
watch(showCountTime, (newVal) => {
  submittingButton.value = newVal
})

return (_ctx: any,_cache: any) => {
  return (_unref(validPostAlum) === 'ERROR_INVALID_PARAMS')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(ErrorMessage, {
          title: _unref(getMessage)(_unref(validPostAlum))
        }, null, 8, ["title"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (invitedCodeNotFound.value == undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3))
          : (invitedCodeNotFound.value)
            ? (_openBlock(), _createBlock(ErrorMessage, {
                key: 1,
                title: _unref(translate)('invalidInvitationUrl')
              }, null, 8, ["title"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("h1", _hoisted_5, [
                  _createTextVNode(_toDisplayString(_unref(inviteData)?.corporation_name) + " ", 1),
                  _hoisted_6,
                  _createTextVNode(" " + _toDisplayString(_unref(inviteData)?.community_name), 1),
                  _hoisted_7,
                  _createTextVNode(" " + _toDisplayString(_unref(translate)('invited')), 1)
                ]),
                _createElementVNode("form", {
                  onSubmit: _cache[80] || (_cache[80] = _withModifiers(() => {}, ["prevent"]))
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    (invalidUrlError.value)
                      ? (_openBlock(), _createBlock(ErrorMessage, {
                          key: 0,
                          title: _unref(translate)('INVALID_URL_ERROR')
                        }, null, 8, ["title"]))
                      : (_unref(validPostAlum))
                        ? (_openBlock(), _createBlock(ErrorMessage, {
                            key: 1,
                            title: _unref(getMessage)(_unref(validPostAlum))
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                    _createElementVNode("h2", _hoisted_9, _toDisplayString(_unref(translate)(`${_unref(ID)}titleFirstTime`)), 1),
                    _createElementVNode("h3", _hoisted_10, _toDisplayString(_unref(translate)(`basicInformation`)), 1),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("label", _hoisted_12, _toDisplayString(_unref(translate)(`${_unref(ID)}fullName`)), 1),
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(Status)
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("label", {
                          class: _normalizeClass(['w-max-content col-form-label text-left', _unref(isMobile) ? 'px-2' : 'family-name'])
                        }, _toDisplayString(_unref(translate)(`${_unref(ID)}surnameKanji`)), 3),
                        _createElementVNode("div", _hoisted_15, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).family_name.$model) = $event)),
                            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(checkNGFamilyName) && _unref(checkNGFamilyName)(...args))),
                            name: "family_name",
                            class: _normalizeClass(['form-control', ngKeyFamilyName.value || _unref(v$).family_name.$error ? 'is-invalid' : '']),
                            placeholder: _unref(placeholderDefault)
                          }, null, 42, _hoisted_16), [
                            [
                              _vModelText,
                              _unref(v$).family_name.$model,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (ngKeyFamilyName.value && !_unref(v$).family_name.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                            : _createCommentVNode("", true),
                          _createVNode(InputErrorMessage, {
                            title: 'surName',
                            params: [1, 20],
                            validator: _unref(v$).family_name.$errors[0]?.$validator
                          }, null, 8, ["validator"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("label", {
                          class: _normalizeClass(['w-max-content col-form-label text-left', _unref(isMobile) ? 'px-2' : 'family-name'])
                        }, _toDisplayString(_unref(translate)(`${_unref(ID)}firstName`)), 3),
                        _createElementVNode("div", _hoisted_19, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).given_name.$model) = $event)),
                            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(checkNGGivenName) && _unref(checkNGGivenName)(...args))),
                            class: _normalizeClass(['form-control', ngKeyGivenName.value || _unref(v$).given_name.$error ? 'is-invalid' : '']),
                            placeholder: _unref(placeholderDefault),
                            name: "given_name"
                          }, null, 42, _hoisted_20), [
                            [
                              _vModelText,
                              _unref(v$).given_name.$model,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (ngKeyGivenName.value && !_unref(v$).given_name.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                            : _createCommentVNode("", true),
                          _createVNode(InputErrorMessage, {
                            title: _unref(translate)(`${_unref(ID)}firstName`),
                            params: [1, 20],
                            validator: _unref(v$).given_name.$errors[0]?.$validator
                          }, null, 8, ["title", "validator"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("label", _hoisted_23, _toDisplayString(_unref(translate)('nameKatakana')), 1),
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(Status)
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("label", {
                          class: _normalizeClass(['w-max-content col-form-label text-left', _unref(isMobile) ? 'px-2' : 'family-name'])
                        }, _toDisplayString(_unref(translate)(`${_unref(ID)}surnameKatakana`)), 3),
                        _createElementVNode("div", _hoisted_26, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).family_name_kana.$model) = $event)),
                            onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(checkNGFamilyNameKana) && _unref(checkNGFamilyNameKana)(...args))),
                            class: _normalizeClass(['form-control', ngKeyFamilyNameKana.value || _unref(v$).family_name_kana.$error ? 'is-invalid' : '']),
                            placeholder: _unref(placeholderDefault),
                            name: "family_name_kana"
                          }, null, 42, _hoisted_27), [
                            [
                              _vModelText,
                              _unref(v$).family_name_kana.$model,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (ngKeyFamilyNameKana.value && !_unref(v$).family_name_kana.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                            : _createCommentVNode("", true),
                          _createVNode(InputErrorMessage, {
                            title: _unref(translate)(`${_unref(ID)}surnameKatakana`),
                            params: [1, 20],
                            validator: _unref(v$).family_name_kana.$errors[0]?.$validator
                          }, null, 8, ["title", "validator"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("label", {
                          class: _normalizeClass(['w-max-content col-form-label text-left', _unref(isMobile) ? 'px-2' : 'family-name'])
                        }, _toDisplayString(_unref(translate)(`${_unref(ID)}firstNameKatakana`)), 3),
                        _createElementVNode("div", _hoisted_30, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: _normalizeClass(['form-control', ngKeyGivenNameKana.value || _unref(v$).given_name_kana.$error ? 'is-invalid' : '']),
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(v$).given_name_kana.$model) = $event)),
                            onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_unref(checkNGGivenNameKana) && _unref(checkNGGivenNameKana)(...args))),
                            placeholder: _unref(placeholderDefault),
                            name: "given_name_kana"
                          }, null, 42, _hoisted_31), [
                            [
                              _vModelText,
                              _unref(v$).given_name_kana.$model,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (ngKeyGivenNameKana.value && !_unref(v$).given_name_kana.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                            : _createCommentVNode("", true),
                          _createVNode(InputErrorMessage, {
                            title: _unref(translate)(`${_unref(ID)}firstNameKatakana`),
                            params: [1, 20],
                            validator: _unref(v$).given_name_kana.$errors[0]?.$validator
                          }, null, 8, ["title", "validator"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("label", _hoisted_34, _toDisplayString(_unref(translate)(`${_unref(ID)}nickName`)), 1),
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(Status)
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: _normalizeClass(['form-control', ngKeyDisplayName.value || _unref(v$).display_name.$error ? 'is-invalid' : '']),
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(v$).display_name.$model) = $event)),
                            onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_unref(checkNGDisplayName) && _unref(checkNGDisplayName)(...args))),
                            placeholder: _unref(placeholderDefault),
                            name: "display_name"
                          }, null, 42, _hoisted_38), [
                            [
                              _vModelText,
                              _unref(v$).display_name.$model,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (ngKeyDisplayName.value && !_unref(v$).display_name.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                            : _createCommentVNode("", true),
                          _createVNode(InputErrorMessage, {
                            title: _unref(translate)(`${_unref(ID)}nickName`),
                            params: [1, 20],
                            validator: _unref(v$).display_name.$errors[0]?.$validator
                          }, null, 8, ["title", "validator"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("label", _hoisted_41, _toDisplayString(_unref(translate)('email')), 1),
                      _createElementVNode("div", _hoisted_42, [
                        _createVNode(Status)
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _withDirectives(_createElementVNode("input", {
                            type: "email",
                            autocomplete: "username",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(v$).email.$model) = $event)),
                            class: _normalizeClass(['form-control', _unref(v$).email.$error || emailSame.value ? 'is-invalid' : '']),
                            placeholder: "sample@yelloop.jp",
                            onKeyup: changeEmail,
                            name: "email"
                          }, null, 34), [
                            [
                              _vModelText,
                              _unref(v$).email.$model,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          _createVNode(InputErrorMessage, {
                            title: _unref(translate)('email'),
                            params: [_unref(MIN_LENGTH_EMAIL), _unref(MAX_LENGTH_EMAIL)],
                            validator: _unref(v$).email.$errors[0]?.$validator
                          }, null, 8, ["title", "params", "validator"]),
                          (emailSame.value && !_unref(v$).email.$error)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_45, _toDisplayString(_unref(getMessage)(emailSame.value)), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("label", _hoisted_47, _toDisplayString(_unref(translate)(`${_unref(ID)}birthday`)), 1),
                      _createElementVNode("div", _hoisted_48, [
                        _createVNode(Status)
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("div", _hoisted_52, [
                              _createVNode(_unref(flatPickr), {
                                modelValue: _unref(v$).birthday.$model,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(v$).birthday.$model) = $event)),
                                config: _unref(getBirthdayConfig)(_unref(v$).birthday.$model),
                                class: _normalizeClass(['form-control bg-white', _unref(v$).birthday.$error ? 'is-invalid' : '']),
                                name: "birthday"
                              }, null, 8, ["modelValue", "config", "class"]),
                              _hoisted_53
                            ]),
                            _createVNode(InputErrorMessage, {
                              title: _unref(translate)(`${_unref(ID)}birthday`),
                              params: [1900, 1, 1],
                              validator: _unref(v$).birthday.$errors[0]?.$validator
                            }, null, 8, ["title", "validator"])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("label", _hoisted_55, _toDisplayString(_unref(translate)(`${_unref(ID)}zipcode`)), 1),
                      _createElementVNode("div", _hoisted_56, [
                        _createVNode(Status)
                      ]),
                      _createElementVNode("div", _hoisted_57, [
                        (formData.value.zipcode_judgment)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                              _createElementVNode("div", _hoisted_59, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "tel",
                                  class: _normalizeClass(['form-control', _unref(v$).zipcode_foreign.$error ? 'is-invalid' : '']),
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(v$).zipcode_foreign.$model) = $event)),
                                  name: "zipcode_foreign"
                                }, null, 2), [
                                  [
                                    _vModelText,
                                    _unref(v$).zipcode_foreign.$model,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                _createVNode(InputErrorMessage, {
                                  title: _unref(translate)(`${_unref(ID)}zipcodeForeign`),
                                  params: [_unref(DEFAULT_MIN_LENGTH), 30],
                                  validator: _unref(v$).zipcode_foreign.$errors[0]?.$validator
                                }, null, 8, ["title", "params", "validator"])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_60, [
                              _createElementVNode("div", _hoisted_61, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "tel",
                                  class: _normalizeClass(['form-control', _unref(v$).zipcode_1.$error ? 'is-invalid' : '']),
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(v$).zipcode_1.$model) = $event)),
                                  name: "zipcode_1"
                                }, null, 2), [
                                  [
                                    _vModelText,
                                    _unref(v$).zipcode_1.$model,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                _createVNode(InputErrorMessage, {
                                  title: _unref(translate)(`${_unref(ID)}zipcode1`),
                                  params: [_unref(DEFAULT_MIN_LENGTH), 3],
                                  validator: _unref(v$).zipcode_1.$errors[0]?.$validator
                                }, null, 8, ["title", "params", "validator"])
                              ]),
                              _hoisted_62,
                              _createElementVNode("div", _hoisted_63, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "tel",
                                  class: _normalizeClass(['form-control', _unref(v$).zipcode_2.$error ? 'is-invalid' : '']),
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(v$).zipcode_2.$model) = $event)),
                                  name: "zipcode_2"
                                }, null, 2), [
                                  [
                                    _vModelText,
                                    _unref(v$).zipcode_2.$model,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                _createVNode(InputErrorMessage, {
                                  title: _unref(translate)(`${_unref(ID)}zipcode2`),
                                  params: [_unref(DEFAULT_MIN_LENGTH), 4],
                                  validator: _unref(v$).zipcode_2.$errors[0]?.$validator
                                }, null, 8, ["title", "params", "validator"])
                              ])
                            ])),
                        _createElementVNode("label", _hoisted_64, [
                          _withDirectives(_createElementVNode("input", {
                            id: "zipcode_judgment",
                            type: "checkbox",
                            class: "mr-1 cursor-pointer form-check-input",
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formData.value.zipcode_judgment) = $event)),
                            name: "zipcode_judgment"
                          }, null, 512), [
                            [_vModelCheckbox, formData.value.zipcode_judgment]
                          ]),
                          _createTextVNode(" " + _toDisplayString(_unref(translate)('outsideJapan')), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("label", _hoisted_66, _toDisplayString(_unref(translate)(`${_unref(ID)}adress`)), 1),
                      _createElementVNode("div", _hoisted_67, [
                        _createVNode(Status)
                      ]),
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("div", _hoisted_69, [
                          _createElementVNode("label", _hoisted_70, _toDisplayString(_unref(translate)(`${_unref(ID)}adress1`)), 1),
                          _createElementVNode("div", _hoisted_71, [
                            _withDirectives(_createElementVNode("select", {
                              class: _normalizeClass(["form-select", ['form-control', _unref(v$).address_1.$error ? 'is-invalid' : '']]),
                              "aria-label": "Default select example",
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(v$).address_1.$model) = $event)),
                              disabled: formData.value.zipcode_judgment,
                              name: "address_1"
                            }, [
                              _createElementVNode("option", _hoisted_73, _toDisplayString(_unref(translate)('placeholderSelect')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listPrefectures.value, (item) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: item.id,
                                  key: item.id
                                }, _toDisplayString(item.name), 9, _hoisted_74))
                              }), 128))
                            ], 10, _hoisted_72), [
                              [_vModelSelect, _unref(v$).address_1.$model]
                            ]),
                            _createVNode(InputErrorMessage, {
                              title: _unref(translate)(`${_unref(ID)}adress1`),
                              validator: _unref(v$).address_1.$errors[0]?.$validator
                            }, null, 8, ["title", "validator"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_75, [
                          _createElementVNode("label", _hoisted_76, _toDisplayString(_unref(translate)(`${_unref(ID)}adress2`)), 1),
                          _createElementVNode("div", _hoisted_77, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: _normalizeClass(['form-control', _unref(v$).address_2.$error ? 'is-invalid' : '']),
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(v$).address_2.$model) = $event)),
                              placeholder: _unref(placeholderDefault),
                              name: "address_2"
                            }, null, 10, _hoisted_78), [
                              [
                                _vModelText,
                                _unref(v$).address_2.$model,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            _createVNode(InputErrorMessage, {
                              title: _unref(translate)(`${_unref(ID)}adress2`),
                              params: [_unref(DEFAULT_MIN_LENGTH), 1000],
                              validator: _unref(v$).address_2.$errors[0]?.$validator
                            }, null, 8, ["title", "params", "validator"])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("label", _hoisted_80, _toDisplayString(_unref(translate)(`${_unref(ID)}phoneNumber`)), 1),
                      _createElementVNode("div", _hoisted_81, [
                        _createVNode(Status)
                      ]),
                      _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("div", _hoisted_83, [
                          _createElementVNode("div", _hoisted_84, [
                            _withDirectives(_createElementVNode("input", {
                              type: "tel",
                              class: _normalizeClass(['form-control', _unref(v$).phone_number_1.$error ? 'is-invalid' : '']),
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(v$).phone_number_1.$model) = $event)),
                              name: "phone_number_1"
                            }, null, 2), [
                              [
                                _vModelText,
                                _unref(v$).phone_number_1.$model,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            _createVNode(InputErrorMessage, {
                              title: _unref(translate)(`${_unref(ID)}phoneNumber1`),
                              params: [_unref(DEFAULT_MIN_LENGTH), 5],
                              validator: _unref(v$).phone_number_1.$errors[0]?.$validator
                            }, null, 8, ["title", "params", "validator"])
                          ]),
                          _hoisted_85,
                          _createElementVNode("div", _hoisted_86, [
                            _withDirectives(_createElementVNode("input", {
                              type: "tel",
                              class: _normalizeClass(['form-control', _unref(v$).phone_number_2.$error ? 'is-invalid' : '']),
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(v$).phone_number_2.$model) = $event)),
                              name: "phone_number_2"
                            }, null, 2), [
                              [
                                _vModelText,
                                _unref(v$).phone_number_2.$model,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            _createVNode(InputErrorMessage, {
                              title: _unref(translate)(`${_unref(ID)}phoneNumber2`),
                              params: [_unref(DEFAULT_MIN_LENGTH), 4],
                              validator: _unref(v$).phone_number_2.$errors[0]?.$validator
                            }, null, 8, ["title", "params", "validator"])
                          ]),
                          _hoisted_87,
                          _createElementVNode("div", _hoisted_88, [
                            _withDirectives(_createElementVNode("input", {
                              type: "tel",
                              class: _normalizeClass(['form-control', _unref(v$).phone_number_3.$error ? 'is-invalid' : '']),
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(v$).phone_number_3.$model) = $event)),
                              name: "phone_number_3"
                            }, null, 2), [
                              [
                                _vModelText,
                                _unref(v$).phone_number_3.$model,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            _createVNode(InputErrorMessage, {
                              title: _unref(translate)(`${_unref(ID)}phoneNumber3`),
                              params: [_unref(DEFAULT_MIN_LENGTH), 4],
                              validator: _unref(v$).phone_number_3.$errors[0]?.$validator
                            }, null, 8, ["title", "params", "validator"])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("h3", _hoisted_89, _toDisplayString(_unref(translate)(`SA20currentJob`)), 1),
                    _createElementVNode("div", _hoisted_90, [
                      _createElementVNode("label", _hoisted_91, _toDisplayString(_unref(translate)('SA20affiliation')), 1),
                      _createElementVNode("div", _hoisted_92, [
                        _createVNode(Status)
                      ]),
                      _createElementVNode("div", _hoisted_93, [
                        _createElementVNode("div", _hoisted_94, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(v$).institution.$model) = $event)),
                            onChange: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_unref(checkNGInstitution) && _unref(checkNGInstitution)(...args))),
                            class: _normalizeClass(['form-control', ngKeyInstitution.value || _unref(v$).institution.$error ? 'is-invalid' : '']),
                            placeholder: _unref(translate)(`SA20placeholderName3`),
                            name: "institution"
                          }, null, 42, _hoisted_95), [
                            [
                              _vModelText,
                              _unref(v$).institution.$model,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (ngKeyInstitution.value && !_unref(v$).institution.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_96, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                            : _createCommentVNode("", true),
                          _createVNode(InputErrorMessage, {
                            title: _unref(translate)(`${_unref(ID)}affiliation`),
                            params: [1, 100],
                            validator: _unref(v$).institution.$errors[0]?.$validator
                          }, null, 8, ["title", "validator"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_97, [
                      _createElementVNode("label", _hoisted_98, _toDisplayString(_unref(translate)(`${_unref(ID)}job`)), 1),
                      _createElementVNode("div", _hoisted_99, [
                        _createVNode(Status)
                      ]),
                      _createElementVNode("div", _hoisted_100, [
                        _createElementVNode("label", _hoisted_101, _toDisplayString(_unref(translate)(`${_unref(ID)}mainJob`)), 1),
                        _createElementVNode("div", _hoisted_102, [
                          _withDirectives(_createElementVNode("select", {
                            class: _normalizeClass(["form-select", ['form-control', _unref(v$).job_type_parent_id.$error ? 'is-invalid' : '']]),
                            "aria-label": "Default select example",
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(v$).job_type_parent_id.$model) = $event)),
                            onChange: _cache[24] || (_cache[24] = ($event: any) => (changeIndexJob(formData.value.job_type_parent_id))),
                            name: "job_type_parent_id"
                          }, [
                            _createElementVNode("option", _hoisted_103, _toDisplayString(_unref(translate)('placeholderSelect')), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listJobs), (item) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: item.id,
                                key: item.id
                              }, _toDisplayString(item.name), 9, _hoisted_104))
                            }), 128))
                          ], 34), [
                            [_vModelSelect, _unref(v$).job_type_parent_id.$model]
                          ]),
                          _createVNode(InputErrorMessage, {
                            title: _unref(translate)(`${_unref(ID)}mainJob`),
                            validator: _unref(v$).job_type_parent_id.$errors[0]?.$validator
                          }, null, 8, ["title", "validator"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_105, [
                        _createElementVNode("label", _hoisted_106, _toDisplayString(_unref(translate)(`${_unref(ID)}subJob`)), 1),
                        _createElementVNode("div", _hoisted_107, [
                          _withDirectives(_createElementVNode("select", {
                            class: _normalizeClass(["form-select", ['form-control', _unref(v$).job_type_child_id.$error ? 'is-invalid' : '']]),
                            "aria-label": "Default select example",
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(v$).job_type_child_id.$model) = $event)),
                            ref: (_value, _refs) => {
                              _refs['selectChild'] = _value
                              selectChild.value = _value
                            },
                            name: "job_type_child_id"
                          }, [
                            _createElementVNode("option", _hoisted_108, _toDisplayString(_unref(translate)('placeholderSelect')), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subJob.value, (item) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: item.id,
                                key: item.id
                              }, _toDisplayString(item.name), 9, _hoisted_109))
                            }), 128))
                          ], 2), [
                            [_vModelSelect, _unref(v$).job_type_child_id.$model]
                          ]),
                          _createVNode(InputErrorMessage, {
                            title: _unref(translate)(`${_unref(ID)}subJob`),
                            validator: _unref(v$).job_type_child_id.$errors[0]?.$validator
                          }, null, 8, ["title", "validator"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_110, [
                      _createElementVNode("label", _hoisted_111, _toDisplayString(_unref(translate)('affiliationPeriod')), 1),
                      _createElementVNode("div", _hoisted_112, [
                        _createVNode(Status)
                      ]),
                      _createElementVNode("div", _hoisted_113, [
                        _createElementVNode("div", _hoisted_114, [
                          _createElementVNode("div", _hoisted_115, [
                            _createElementVNode("div", _hoisted_116, [
                              _createVNode(_unref(flatPickr), {
                                modelValue: _unref(v$).enrollment_start_period.$model,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_unref(v$).enrollment_start_period.$model) = $event)),
                                config: _unref(configYM)(_unref(v$).enrollment_start_period.$model),
                                class: _normalizeClass(['form-control bg-white', _unref(v$).enrollment_start_period.$error ? 'is-invalid' : '']),
                                name: "enrollment_start_period"
                              }, null, 8, ["modelValue", "config", "class"]),
                              _hoisted_117
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_118, _toDisplayString(_unref(translate)('SA20dateNow')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_119, [
                          _createElementVNode("div", {
                            class: _normalizeClass([_unref(v$).enrollment_start_period.$error ? 'is-invalid' : ''])
                          }, null, 2),
                          _createVNode(InputErrorMessage, {
                            title: _unref(translate)('affiliationPeriod'),
                            params: [1900, 1],
                            validator: _unref(v$).enrollment_start_period.$errors[0]?.$validator
                          }, null, 8, ["title", "validator"])
                        ])
                      ])
                    ]),
                    _createElementVNode("h3", _hoisted_120, _toDisplayString(_unref(translate)(`${_unref(ID)}passwordSecret`)), 1),
                    _createElementVNode("div", _hoisted_121, [
                      _createElementVNode("label", _hoisted_122, _toDisplayString(_unref(translate)('password')), 1),
                      _createElementVNode("div", _hoisted_123, [
                        _createVNode(Status)
                      ]),
                      _createElementVNode("div", _hoisted_124, [
                        _createElementVNode("div", _hoisted_125, [
                          _withDirectives(_createElementVNode("input", {
                            type: "password",
                            class: _normalizeClass(['form-control', _unref(v$).password.$error ? 'is-invalid' : '']),
                            placeholder: _unref(placeholderDefault),
                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_unref(v$).password.$model) = $event)),
                            name: "password"
                          }, null, 10, _hoisted_126), [
                            [
                              _vModelText,
                              _unref(v$).password.$model,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          _createVNode(InputErrorMessage, {
                            title: 'password',
                            params: [8, 128],
                            validator: _unref(v$).password.$errors[0]?.$validator
                          }, null, 8, ["validator"])
                        ]),
                        _createElementVNode("p", null, _toDisplayString(_unref(translate)('SA20noticePass')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_127, [
                      _createElementVNode("label", _hoisted_128, _toDisplayString(_unref(translate)(`${_unref(ID)}passwordConfirm`)), 1),
                      _createElementVNode("div", _hoisted_129, [
                        _createVNode(Status)
                      ]),
                      _createElementVNode("div", _hoisted_130, [
                        _createElementVNode("div", _hoisted_131, [
                          _withDirectives(_createElementVNode("input", {
                            type: "password",
                            class: _normalizeClass(['form-control', _unref(v$).confirmPassword.$error ? 'is-invalid' : '']),
                            placeholder: _unref(placeholderDefault),
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref(v$).confirmPassword.$model) = $event)),
                            name: "confirm_password"
                          }, null, 10, _hoisted_132), [
                            [
                              _vModelText,
                              _unref(v$).confirmPassword.$model,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          _createVNode(InputErrorMessage, {
                            title: _unref(translate)(`${_unref(ID)}passwordConfirm`),
                            params: [8, 128],
                            validator: _unref(v$).confirmPassword.$errors[0]?.$validator
                          }, null, 8, ["title", "validator"])
                        ]),
                        _createElementVNode("p", null, _toDisplayString(_unref(translate)('SB20noticePassConfirm')), 1)
                      ])
                    ]),
                    _createElementVNode("h3", _hoisted_133, _toDisplayString(_unref(translate)(`twoFA`)), 1),
                    _createElementVNode("div", _hoisted_134, [
                      _createElementVNode("label", _hoisted_135, _toDisplayString(_unref(translate)(`method`)), 1),
                      _createElementVNode("div", _hoisted_136, [
                        _createVNode(Status)
                      ]),
                      _createElementVNode("div", _hoisted_137, [
                        _createElementVNode("div", _hoisted_138, [
                          _createElementVNode("div", _hoisted_139, [
                            _createElementVNode("label", _hoisted_140, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                type: "radio",
                                name: "authentication_method",
                                value: _unref(AuthenMethodTypes).SMS,
                                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_unref(v$).authentication_method.$model) = $event))
                              }, null, 8, _hoisted_141), [
                                [_vModelRadio, _unref(v$).authentication_method.$model]
                              ]),
                              _createTextVNode(" " + _toDisplayString(_unref(translate)(`useSMS`)), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_142, [
                            _createElementVNode("label", _hoisted_143, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                type: "radio",
                                name: "authentication_method",
                                value: _unref(AuthenMethodTypes).EMAIL,
                                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_unref(v$).authentication_method.$model) = $event))
                              }, null, 8, _hoisted_144), [
                                [_vModelRadio, _unref(v$).authentication_method.$model]
                              ]),
                              _createTextVNode(" " + _toDisplayString(_unref(translate)(`useEmail`)), 1)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_145, [
                      _createElementVNode("label", _hoisted_146, _toDisplayString(_unref(v$).authentication_method.$model !== _unref(AuthenMethodTypes).EMAIL ? _unref(translate)(`phone`) : _unref(translate)(`email`)), 1),
                      _createElementVNode("div", _hoisted_147, [
                        _createElementVNode("div", _hoisted_148, [
                          _createElementVNode("div", _hoisted_149, [
                            (_unref(v$).authentication_method.$model !== _unref(AuthenMethodTypes).EMAIL)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass(['form-control', 'show-info-field']),
                                  name: "phone",
                                  title: _unref(fullPhoneNumber)?.trim()
                                }, _toDisplayString(_unref(fullPhoneNumber) || _unref(translate)(`phoneExample`)), 9, _hoisted_150))
                              : (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: _normalizeClass(['form-control', 'show-info-field']),
                                  name: "email",
                                  title: formData.value.email?.trim()
                                }, _toDisplayString(_unref(v$).email.$model || 'sample@yelloop.jp'), 9, _hoisted_151)),
                            _createElementVNode("div", {
                              class: _normalizeClass(['col-lg-12 col-form-label fs-7 while-spaces', { 'text-danger': _unref(v$).authentication_method.$model === _unref(AuthenMethodTypes).SMS }])
                            }, _toDisplayString(_unref(v$).authentication_method.$model !== _unref(AuthenMethodTypes).EMAIL ? _unref(translate)(`showPhoneMessage`) : _unref(translate)(`showEmailMessage`)), 3),
                            (_unref(v$).authentication_method.$model !== _unref(AuthenMethodTypes).EMAIL)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_152, [
                                  (_unref(v$).authentication_method.$model !== _unref(AuthenMethodTypes).EMAIL)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "button-test shadow button-router-link",
                                        disabled: 
                        _unref(v$).phone_number_1.$error ||
                        _unref(v$).phone_number_2.$error ||
                        _unref(v$).phone_number_3.$error ||
                        !_unref(v$).phone_number_1.$model ||
                        !_unref(v$).phone_number_2.$model ||
                        !_unref(v$).phone_number_3.$model ||
                        _unref(showCountTime) ||
                        submittingButton.value
                      ,
                                        onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_unref(sendTestPhoneNumber) && _unref(sendTestPhoneNumber)(...args)))
                                      }, _toDisplayString(_unref(translate)(`testSend`)), 9, _hoisted_153))
                                    : _createCommentVNode("", true),
                                  (_unref(showCountTime))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_154, _toDisplayString(_unref(timeLeft)) + "秒後に再送可能です ", 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  (!disableCorporation.value || !disableSchool.value || !disableInformation.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_155, [
                        _createElementVNode("h2", _hoisted_156, _toDisplayString(_unref(translate)(`${_unref(ID)}titleForCommunity`, _unref(inviteData)?.corporation_name)), 1),
                        _createElementVNode("div", _hoisted_157, [
                          _createVNode(TargetTag, {
                            data: _unref(communityRequiredData)?.supplementary_information,
                            class: _normalizeClass([fullContent.value ? '' : 'p_content'])
                          }, null, 8, ["data", "class"]),
                          (seeMoreBtn.value > 72 && !fullContent.value)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "span-text text-decoration-underline cursor-pointer",
                                onClick: SeeMore
                              }, _toDisplayString(_unref(translate)('seeMore')), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: "text-break break-spaces real_height position-absolute",
                            ref: (_value, _refs) => {
                              _refs['supplementaryInformation'] = _value
                              supplementaryInformation.value = _value
                            },
                            innerHTML: _unref(purifyContent)(_unref(communityRequiredData)?.supplementary_information)
                          }, null, 8, _hoisted_158)
                        ]),
                        (!disableCorporation.value)
                          ? (_openBlock(), _createElementBlock("h3", _hoisted_159, _toDisplayString(_unref(translate)(`${_unref(ID)}enrollment`)), 1))
                          : _createCommentVNode("", true),
                        (_unref(communityRequiredData).corporation_organization_name === 1 || _unref(communityRequiredData).corporation_organization_name === 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_160, [
                              _createElementVNode("label", _hoisted_161, _toDisplayString(_unref(translate)(`${_unref(ID)}corporationOrganizationName`)), 1),
                              _createElementVNode("div", _hoisted_162, [
                                (_unref(communityRequiredData).corporation_organization_name === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_163, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_164, [
                                _createElementVNode("div", _hoisted_165, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: _normalizeClass(['form-control', ngKeyCorporationOrganizationName.value || _unref(v$).corporation_organization_name.$error ? 'is-invalid' : '']),
                                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_unref(v$).corporation_organization_name.$model) = $event)),
                                    onChange: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_unref(checkNGCorporationOrganizationName) && _unref(checkNGCorporationOrganizationName)(...args))),
                                    placeholder: _unref(placeholderDefault),
                                    name: "corporation_organization_name"
                                  }, null, 42, _hoisted_166), [
                                    [
                                      _vModelText,
                                      _unref(v$).corporation_organization_name.$model,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (ngKeyCorporationOrganizationName.value && !_unref(v$).corporation_organization_name.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_167, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                    : _createCommentVNode("", true),
                                  _createVNode(InputErrorMessage, {
                                    title: _unref(translate)(`${_unref(ID)}corporationOrganizationName`),
                                    params: [1, 100],
                                    validator: _unref(v$).corporation_organization_name.$errors[0]?.$validator
                                  }, null, 8, ["title", "validator"])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(communityRequiredData).corporation_department_name === 1 || _unref(communityRequiredData).corporation_department_name === 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_168, [
                              _createElementVNode("label", _hoisted_169, _toDisplayString(_unref(translate)(`${_unref(ID)}department`)), 1),
                              _createElementVNode("div", _hoisted_170, [
                                (_unref(communityRequiredData).corporation_department_name === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_171, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_172, [
                                _createElementVNode("div", _hoisted_173, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: _normalizeClass(['form-control', ngKeyCorporationDepartmentName.value || _unref(v$).corporation_department_name.$error ? 'is-invalid' : '']),
                                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_unref(v$).corporation_department_name.$model) = $event)),
                                    onChange: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_unref(checkNGCorporationDepartmentName) && _unref(checkNGCorporationDepartmentName)(...args))),
                                    placeholder: _unref(translate)(`${_unref(ID)}placeholderDepartment`),
                                    name: "corporation_department_name"
                                  }, null, 42, _hoisted_174), [
                                    [
                                      _vModelText,
                                      _unref(v$).corporation_department_name.$model,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (ngKeyCorporationDepartmentName.value && !_unref(v$).corporation_department_name.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_175, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                    : _createCommentVNode("", true),
                                  _createVNode(InputErrorMessage, {
                                    title: _unref(translate)(`${_unref(ID)}department`),
                                    params: [1, 100],
                                    validator: _unref(v$).corporation_department_name.$errors[0]?.$validator
                                  }, null, 8, ["title", "validator"])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (
              (_unref(communityRequiredData).corporation_start_period === 1 && _unref(communityRequiredData).corporation_end_period === 1) ||
              (_unref(communityRequiredData).corporation_start_period === 2 && _unref(communityRequiredData).corporation_end_period === 2)
            )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_176, [
                              _createElementVNode("label", _hoisted_177, _toDisplayString(_unref(translate)(`${_unref(ID)}enrollmentPeriod`)), 1),
                              _createElementVNode("div", _hoisted_178, [
                                (_unref(communityRequiredData).corporation_start_period === 1 && _unref(communityRequiredData).corporation_end_period === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_179, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_180, [
                                _createElementVNode("div", _hoisted_181, [
                                  _createElementVNode("div", _hoisted_182, [
                                    _createElementVNode("div", _hoisted_183, [
                                      _createVNode(_unref(flatPickr), {
                                        modelValue: _unref(v$).corporation_start_period.$model,
                                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_unref(v$).corporation_start_period.$model) = $event)),
                                        config: _unref(configYM)(_unref(v$).corporation_start_period.$model),
                                        class: _normalizeClass(['form-control bg-white', _unref(v$).corporation_start_period.$error ? 'is-invalid' : '']),
                                        name: "corporation_start_period"
                                      }, null, 8, ["modelValue", "config", "class"]),
                                      _hoisted_184
                                    ]),
                                    _createVNode(InputErrorMessage, {
                                      title: _unref(translate)(`SA20fromEnrollmentPeriod`),
                                      params: [1900, 1],
                                      validator: _unref(v$).corporation_start_period.$errors[0]?.$validator
                                    }, null, 8, ["title", "validator"])
                                  ]),
                                  _createElementVNode("div", _hoisted_185, _toDisplayString(_unref(translate)('SA20from')), 1),
                                  _createElementVNode("div", _hoisted_186, [
                                    _createElementVNode("div", _hoisted_187, [
                                      _createVNode(_unref(flatPickr), {
                                        modelValue: _unref(v$).corporation_end_period.$model,
                                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_unref(v$).corporation_end_period.$model) = $event)),
                                        config: _unref(configYM)(_unref(v$).corporation_end_period.$model),
                                        class: _normalizeClass(['form-control bg-white', _unref(v$).corporation_end_period.$error ? 'is-invalid' : '']),
                                        name: "corporation_end_period"
                                      }, null, 8, ["modelValue", "config", "class"]),
                                      _hoisted_188
                                    ]),
                                    _createVNode(InputErrorMessage, {
                                      title: _unref(translate)(`SA20toEnrollmentPeriod`),
                                      params: [1900, 1],
                                      validator: _unref(v$).corporation_end_period.$errors[0]?.$validator
                                    }, null, 8, ["title", "validator"])
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(communityRequiredData).corporation_employee_id === 1 || _unref(communityRequiredData).corporation_employee_id === 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_189, [
                              _createElementVNode("label", _hoisted_190, _toDisplayString(_unref(translate)(`${_unref(ID)}employeeID`)), 1),
                              _createElementVNode("div", _hoisted_191, [
                                (_unref(communityRequiredData).corporation_employee_id === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_192, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_193, [
                                _createElementVNode("div", _hoisted_194, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_unref(v$).corporation_employee_id.$model) = $event)),
                                    class: _normalizeClass(['form-control', _unref(v$).corporation_employee_id.$error ? 'is-invalid' : '']),
                                    placeholder: _unref(translate)(`${_unref(ID)}placeholderID`),
                                    name: "corporation_employee_id"
                                  }, null, 10, _hoisted_195), [
                                    [
                                      _vModelText,
                                      _unref(v$).corporation_employee_id.$model,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  _createVNode(InputErrorMessage, {
                                    title: _unref(translate)(`${_unref(ID)}employeeID`),
                                    params: [1, 20],
                                    validator: _unref(v$).corporation_employee_id.$errors[0]?.$validator
                                  }, null, 8, ["title", "validator"])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(communityRequiredData).corporation_email === 1 || _unref(communityRequiredData).corporation_email === 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_196, [
                              _createElementVNode("label", _hoisted_197, _toDisplayString(_unref(translate)(`${_unref(ID)}emailEnrollment`)), 1),
                              _createElementVNode("div", _hoisted_198, [
                                (_unref(communityRequiredData).corporation_email === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_199, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_200, [
                                _createElementVNode("div", _hoisted_201, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "email",
                                    "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_unref(v$).corporation_email.$model) = $event)),
                                    class: _normalizeClass(['form-control', _unref(v$).corporation_email.$error ? 'is-invalid' : '']),
                                    placeholder: "sample@yelloop.jp",
                                    name: "corporation_email"
                                  }, null, 2), [
                                    [
                                      _vModelText,
                                      _unref(v$).corporation_email.$model,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  _createVNode(InputErrorMessage, {
                                    title: _unref(translate)(`${_unref(ID)}emailEnrollment`),
                                    params: [_unref(MIN_LENGTH_EMAIL), _unref(MAX_LENGTH_EMAIL)],
                                    validator: _unref(v$).corporation_email.$errors[0]?.$validator
                                  }, null, 8, ["title", "params", "validator"])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (
              (_unref(communityRequiredData).corporation_given_name === 1 && _unref(communityRequiredData).corporation_family_name === 1) ||
              (_unref(communityRequiredData).corporation_given_name === 2 && _unref(communityRequiredData).corporation_family_name === 2)
            )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_202, [
                              _createElementVNode("label", _hoisted_203, _toDisplayString(_unref(translate)(`OE30nameAtTime`)), 1),
                              _createElementVNode("div", _hoisted_204, [
                                (_unref(communityRequiredData).corporation_given_name === 1 && _unref(communityRequiredData).corporation_family_name === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_205, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_206, [
                                _createElementVNode("label", {
                                  class: _normalizeClass(['w-max-content col-form-label text-left', _unref(isMobile) ? 'px-2' : 'name-kanji'])
                                }, _toDisplayString(_unref(translate)(`${_unref(ID)}surnameKanji`)), 3),
                                _createElementVNode("div", _hoisted_207, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_unref(v$).corporation_family_name.$model) = $event)),
                                    onChange: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_unref(checkNGCorporationFamilyName) && _unref(checkNGCorporationFamilyName)(...args))),
                                    class: _normalizeClass(['form-control', ngKeyCorporationFamilyName.value || _unref(v$).corporation_family_name.$error ? 'is-invalid' : '']),
                                    placeholder: _unref(placeholderDefault),
                                    name: "corporation_family_name"
                                  }, null, 42, _hoisted_208), [
                                    [
                                      _vModelText,
                                      _unref(v$).corporation_family_name.$model,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (ngKeyCorporationFamilyName.value && !_unref(v$).corporation_family_name.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_209, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                    : _createCommentVNode("", true),
                                  _createVNode(InputErrorMessage, {
                                    title: _unref(translate)(`${_unref(ID)}surnameKanji`),
                                    params: [1, 20],
                                    validator: _unref(v$).corporation_family_name.$errors[0]?.$validator
                                  }, null, 8, ["title", "validator"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_210, [
                                _createElementVNode("label", {
                                  class: _normalizeClass(['w-max-content col-form-label text-left', _unref(isMobile) ? 'px-2' : 'name-kanji'])
                                }, _toDisplayString(_unref(translate)(`${_unref(ID)}firstName`)), 3),
                                _createElementVNode("div", _hoisted_211, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_unref(v$).corporation_given_name.$model) = $event)),
                                    onChange: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => (_unref(checkNGCorporationGivenName) && _unref(checkNGCorporationGivenName)(...args))),
                                    class: _normalizeClass(['form-control', ngKeyCorporationGivenName.value || _unref(v$).corporation_given_name.$error ? 'is-invalid' : '']),
                                    placeholder: _unref(placeholderDefault),
                                    name: "corporation_given_name"
                                  }, null, 42, _hoisted_212), [
                                    [
                                      _vModelText,
                                      _unref(v$).corporation_given_name.$model,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (ngKeyCorporationGivenName.value && !_unref(v$).corporation_given_name.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_213, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                    : _createCommentVNode("", true),
                                  _createVNode(InputErrorMessage, {
                                    title: _unref(translate)(`${_unref(ID)}firstName`),
                                    params: [1, 20],
                                    validator: _unref(v$).corporation_given_name.$errors[0]?.$validator
                                  }, null, 8, ["title", "validator"])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (!disableSchool.value)
                          ? (_openBlock(), _createElementBlock("h3", _hoisted_214, _toDisplayString(_unref(translate)(`${_unref(ID)}informationAtSchool`)), 1))
                          : _createCommentVNode("", true),
                        (_unref(communityRequiredData).school_organization_name === 1 || _unref(communityRequiredData).school_organization_name === 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_215, [
                              _createElementVNode("label", _hoisted_216, _toDisplayString(_unref(translate)(`${_unref(ID)}schoolOrganizationName`)), 1),
                              _createElementVNode("div", _hoisted_217, [
                                (_unref(communityRequiredData).school_organization_name === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_218, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_219, [
                                _createElementVNode("div", _hoisted_220, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: _normalizeClass(['form-control', ngKeySchoolOrganizationName.value || _unref(v$).school_organization_name.$error ? 'is-invalid' : '']),
                                    "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_unref(v$).school_organization_name.$model) = $event)),
                                    onChange: _cache[45] || (_cache[45] = 
//@ts-ignore
(...args) => (_unref(checkNGSchoolOrganizationName) && _unref(checkNGSchoolOrganizationName)(...args))),
                                    placeholder: _unref(placeholderDefault),
                                    name: "school_organization_name"
                                  }, null, 42, _hoisted_221), [
                                    [
                                      _vModelText,
                                      _unref(v$).school_organization_name.$model,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (ngKeySchoolOrganizationName.value && !_unref(v$).school_organization_name.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_222, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                    : _createCommentVNode("", true),
                                  _createVNode(InputErrorMessage, {
                                    title: _unref(translate)(`${_unref(ID)}schoolOrganizationName`),
                                    params: [1, 100],
                                    validator: _unref(v$).school_organization_name.$errors[0]?.$validator
                                  }, null, 8, ["title", "validator"])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(communityRequiredData).school_faclty_name === 1 || _unref(communityRequiredData).school_faclty_name === 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_223, [
                              _createElementVNode("label", _hoisted_224, _toDisplayString(_unref(translate)(`${_unref(ID)}facultyName`)), 1),
                              _createElementVNode("div", _hoisted_225, [
                                (_unref(communityRequiredData).school_faclty_name === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_226, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_227, [
                                _createElementVNode("div", _hoisted_228, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: _normalizeClass(['form-control', ngKeySchoolFacltyName.value || _unref(v$).school_faclty_name.$error ? 'is-invalid' : '']),
                                    "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_unref(v$).school_faclty_name.$model) = $event)),
                                    onChange: _cache[47] || (_cache[47] = 
//@ts-ignore
(...args) => (_unref(checkNGSchoolFacltyName) && _unref(checkNGSchoolFacltyName)(...args))),
                                    placeholder: _unref(translate)(`SA20placeholderName1`),
                                    name: "school_faclty_name"
                                  }, null, 42, _hoisted_229), [
                                    [
                                      _vModelText,
                                      _unref(v$).school_faclty_name.$model,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (ngKeySchoolFacltyName.value && !_unref(v$).school_faclty_name.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_230, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                    : _createCommentVNode("", true),
                                  _createVNode(InputErrorMessage, {
                                    title: _unref(translate)(`${_unref(ID)}facultyName`),
                                    params: [1, 100],
                                    validator: _unref(v$).school_faclty_name.$errors[0]?.$validator
                                  }, null, 8, ["title", "validator"])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(communityRequiredData).school_department_name === 1 || _unref(communityRequiredData).school_department_name === 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_231, [
                              _createElementVNode("label", _hoisted_232, _toDisplayString(_unref(translate)(`${_unref(ID)}departmentName`)), 1),
                              _createElementVNode("div", _hoisted_233, [
                                (_unref(communityRequiredData).school_department_name === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_234, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_235, [
                                _createElementVNode("div", _hoisted_236, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: _normalizeClass(['form-control', ngKeySchoolDepartmentName.value || _unref(v$).school_department_name.$error ? 'is-invalid' : '']),
                                    "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_unref(v$).school_department_name.$model) = $event)),
                                    onChange: _cache[49] || (_cache[49] = 
//@ts-ignore
(...args) => (_unref(checkNGSchoolDepartmentName) && _unref(checkNGSchoolDepartmentName)(...args))),
                                    placeholder: _unref(translate)(`SA20placeholderName2`),
                                    name: "school_department_name"
                                  }, null, 42, _hoisted_237), [
                                    [
                                      _vModelText,
                                      _unref(v$).school_department_name.$model,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (ngKeySchoolDepartmentName.value && !_unref(v$).school_department_name.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_238, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                    : _createCommentVNode("", true),
                                  _createVNode(InputErrorMessage, {
                                    title: _unref(translate)(`${_unref(ID)}departmentName`),
                                    params: [1, 100],
                                    validator: _unref(v$).school_department_name.$errors[0]?.$validator
                                  }, null, 8, ["title", "validator"])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (
              (_unref(communityRequiredData).school_start_period === 1 && _unref(communityRequiredData).school_end_period === 1) ||
              (_unref(communityRequiredData).school_start_period === 2 && _unref(communityRequiredData).school_end_period === 2)
            )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_239, [
                              _createElementVNode("label", _hoisted_240, _toDisplayString(_unref(translate)(`${_unref(ID)}periodOfEnrollment`)), 1),
                              _createElementVNode("div", _hoisted_241, [
                                (_unref(communityRequiredData).school_start_period === 1 && _unref(communityRequiredData).school_end_period === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_242, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_243, [
                                _createElementVNode("div", _hoisted_244, [
                                  _createElementVNode("div", _hoisted_245, [
                                    _createElementVNode("div", _hoisted_246, [
                                      _createVNode(_unref(flatPickr), {
                                        modelValue: _unref(v$).school_start_period.$model,
                                        "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_unref(v$).school_start_period.$model) = $event)),
                                        config: _unref(configYM)(_unref(v$).school_start_period.$model),
                                        class: _normalizeClass(['form-control bg-white', _unref(v$).school_start_period.$error ? 'is-invalid' : '']),
                                        name: "school_start_period"
                                      }, null, 8, ["modelValue", "config", "class"]),
                                      _hoisted_247
                                    ]),
                                    _createVNode(InputErrorMessage, {
                                      title: _unref(translate)(`SA20fromPeriodOfEnrollment`),
                                      params: [1900, 1],
                                      validator: _unref(v$).school_start_period.$errors[0]?.$validator
                                    }, null, 8, ["title", "validator"])
                                  ]),
                                  _createElementVNode("div", _hoisted_248, _toDisplayString(_unref(translate)('SA20from')), 1),
                                  _createElementVNode("div", _hoisted_249, [
                                    _createElementVNode("div", _hoisted_250, [
                                      _createVNode(_unref(flatPickr), {
                                        modelValue: _unref(v$).school_end_period.$model,
                                        "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_unref(v$).school_end_period.$model) = $event)),
                                        config: _unref(configYM)(_unref(v$).school_end_period.$model),
                                        class: _normalizeClass(['form-control bg-white', _unref(v$).school_end_period.$error ? 'is-invalid' : '']),
                                        name: "school_end_period"
                                      }, null, 8, ["modelValue", "config", "class"]),
                                      _hoisted_251
                                    ]),
                                    _createVNode(InputErrorMessage, {
                                      title: _unref(translate)(`SA20toPeriodOfEnrollment`),
                                      params: [1900, 1],
                                      validator: _unref(v$).school_end_period.$errors[0]?.$validator
                                    }, null, 8, ["title", "validator"])
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(communityRequiredData).school_student_id === 1 || _unref(communityRequiredData).school_student_id === 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_252, [
                              _createElementVNode("label", _hoisted_253, _toDisplayString(_unref(translate)(`${_unref(ID)}studentID`)), 1),
                              _createElementVNode("div", _hoisted_254, [
                                (_unref(communityRequiredData).school_student_id === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_255, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_256, [
                                _createElementVNode("div", _hoisted_257, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_unref(v$).school_student_id.$model) = $event)),
                                    class: _normalizeClass(['form-control', _unref(v$).school_student_id.$error ? 'is-invalid' : '']),
                                    placeholder: _unref(translate)(`${_unref(ID)}placeholderID`),
                                    name: "school_student_id"
                                  }, null, 10, _hoisted_258), [
                                    [
                                      _vModelText,
                                      _unref(v$).school_student_id.$model,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  _createVNode(InputErrorMessage, {
                                    title: _unref(translate)(`${_unref(ID)}studentID`),
                                    params: [1, 20],
                                    validator: _unref(v$).school_student_id.$errors[0]?.$validator
                                  }, null, 8, ["title", "validator"])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(communityRequiredData).school_email === 1 || _unref(communityRequiredData).school_email === 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_259, [
                              _createElementVNode("label", _hoisted_260, _toDisplayString(_unref(translate)(`${_unref(ID)}emailAttendSchool`)), 1),
                              _createElementVNode("div", _hoisted_261, [
                                (_unref(communityRequiredData).school_email === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_262, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_263, [
                                _createElementVNode("div", _hoisted_264, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "email",
                                    "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_unref(v$).school_email.$model) = $event)),
                                    class: _normalizeClass(['form-control', _unref(v$).school_email.$error ? 'is-invalid' : '']),
                                    placeholder: "sample@yelloop.jp",
                                    name: "school_email"
                                  }, null, 2), [
                                    [
                                      _vModelText,
                                      _unref(v$).school_email.$model,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  _createVNode(InputErrorMessage, {
                                    title: _unref(translate)(`${_unref(ID)}emailAttendSchool`),
                                    params: [_unref(MIN_LENGTH_EMAIL), _unref(MAX_LENGTH_EMAIL)],
                                    validator: _unref(v$).school_email.$errors[0]?.$validator
                                  }, null, 8, ["title", "params", "validator"])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (
              (_unref(communityRequiredData).school_family_name === 1 && _unref(communityRequiredData).school_given_name === 1) ||
              (_unref(communityRequiredData).school_family_name === 2 && _unref(communityRequiredData).school_given_name === 2)
            )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_265, [
                              _createElementVNode("label", _hoisted_266, _toDisplayString(_unref(translate)(`${_unref(ID)}nameAtSchool`)), 1),
                              _createElementVNode("div", _hoisted_267, [
                                (_unref(communityRequiredData).school_family_name === 1 && _unref(communityRequiredData).school_given_name === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_268, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_269, [
                                _createElementVNode("label", {
                                  class: _normalizeClass(['w-max-content col-form-label text-left', _unref(isMobile) ? 'px-2' : 'name-kanji'])
                                }, _toDisplayString(_unref(translate)(`${_unref(ID)}surnameKanji`)), 3),
                                _createElementVNode("div", _hoisted_270, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_unref(v$).school_family_name.$model) = $event)),
                                    onChange: _cache[55] || (_cache[55] = 
//@ts-ignore
(...args) => (_unref(checkNGSchoolFamilyName) && _unref(checkNGSchoolFamilyName)(...args))),
                                    class: _normalizeClass(['form-control', ngKeySchoolFamilyName.value || _unref(v$).school_family_name.$error ? 'is-invalid' : '']),
                                    placeholder: _unref(placeholderDefault),
                                    name: "school_family_name"
                                  }, null, 42, _hoisted_271), [
                                    [
                                      _vModelText,
                                      _unref(v$).school_family_name.$model,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (ngKeySchoolFamilyName.value && !_unref(v$).school_family_name.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_272, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                    : _createCommentVNode("", true),
                                  _createVNode(InputErrorMessage, {
                                    title: _unref(translate)(`${_unref(ID)}surnameKanji`),
                                    params: [1, 20],
                                    validator: _unref(v$).school_family_name.$errors[0]?.$validator
                                  }, null, 8, ["title", "validator"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_273, [
                                _createElementVNode("label", {
                                  class: _normalizeClass(['w-max-content col-form-label text-left', _unref(isMobile) ? 'px-2' : 'name-kanji'])
                                }, _toDisplayString(_unref(translate)(`${_unref(ID)}firstName`)), 3),
                                _createElementVNode("div", _hoisted_274, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_unref(v$).school_given_name.$model) = $event)),
                                    onChange: _cache[57] || (_cache[57] = 
//@ts-ignore
(...args) => (_unref(checkNGSchoolGivenName) && _unref(checkNGSchoolGivenName)(...args))),
                                    class: _normalizeClass(['form-control', ngKeySchoolGivenName.value || _unref(v$).school_given_name.$error ? 'is-invalid' : '']),
                                    placeholder: _unref(placeholderDefault),
                                    name: "school_given_name"
                                  }, null, 42, _hoisted_275), [
                                    [
                                      _vModelText,
                                      _unref(v$).school_given_name.$model,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (ngKeySchoolGivenName.value && !_unref(v$).school_given_name.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_276, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                    : _createCommentVNode("", true),
                                  _createVNode(InputErrorMessage, {
                                    title: _unref(translate)(`${_unref(ID)}firstName`),
                                    params: [1, 20],
                                    validator: _unref(v$).school_given_name.$errors[0]?.$validator
                                  }, null, 8, ["title", "validator"])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (!disableInformation.value)
                          ? (_openBlock(), _createElementBlock("h3", _hoisted_277, _toDisplayString(_unref(translate)('additionalInformation')), 1))
                          : _createCommentVNode("", true),
                        (_unref(communityRequiredData).additional_information_1 === 1 || _unref(communityRequiredData).additional_information_1 === 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_278, [
                              _createElementVNode("label", _hoisted_279, [
                                _createTextVNode(_toDisplayString(_unref(communityRequiredData).additional_information_1_question) + " ", 1),
                                (
                  _unref(communityRequiredData)?.additional_information_1_setting?.type == _unref(ALUMNI_QUESTION_TYPE).MULTIPLE_CHOICE &&
                  _unref(communityRequiredData)?.additional_information_1_setting?.data?.length > 1
                )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_280, _toDisplayString(_unref(translate)('multipleSelectionsPossible')), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_281, [
                                (_unref(communityRequiredData).additional_information_1 === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_282, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              (_unref(communityRequiredData)?.additional_information_1_setting?.type == _unref(ALUMNI_QUESTION_TYPE).FREE_TEXT)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_283, [
                                    _createElementVNode("div", _hoisted_284, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: _normalizeClass(['form-control', ngKeyAdditionalInformation1.value || _unref(v$).additional_information_1.$error ? 'is-invalid' : '']),
                                        "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_unref(v$).additional_information_1.$model) = $event)),
                                        onChange: _cache[59] || (_cache[59] = 
//@ts-ignore
(...args) => (_unref(checkNGAdditionalInformation1) && _unref(checkNGAdditionalInformation1)(...args))),
                                        placeholder: _unref(placeholderDefault),
                                        name: "additional_information_1"
                                      }, null, 42, _hoisted_285), [
                                        [
                                          _vModelText,
                                          _unref(v$).additional_information_1.$model,
                                          void 0,
                                          { trim: true }
                                        ]
                                      ]),
                                      (ngKeyAdditionalInformation1.value && !_unref(v$).additional_information_1.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_286, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                        : _createCommentVNode("", true),
                                      _createVNode(InputErrorMessage, {
                                        title: _unref(communityRequiredData).additional_information_1_question,
                                        params: [1, 100],
                                        validator: _unref(v$).additional_information_1.$errors[0]?.$validator
                                      }, null, 8, ["title", "validator"])
                                    ])
                                  ]))
                                : (_unref(communityRequiredData)?.additional_information_1_setting?.type == _unref(ALUMNI_QUESTION_TYPE).SINGLE_CHOICE)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_287, [
                                      _createElementVNode("div", _hoisted_288, [
                                        _withDirectives(_createElementVNode("select", {
                                          class: _normalizeClass(["form-select", ['form-control', _unref(vCheckbox$).additional_information_select1.$error ? 'is-invalid' : '']]),
                                          "aria-label": "Default select example",
                                          "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_unref(vCheckbox$).additional_information_select1.$model) = $event)),
                                          ref: (_value, _refs) => {
                                            _refs['selectChild'] = _value
                                            selectChild.value = _value
                                          }
                                        }, [
                                          _createElementVNode("option", _hoisted_289, _toDisplayString(_unref(translate)('placeholderSelect')), 1),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(communityRequiredData)?.additional_information_1_setting?.data, (item, index) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                              value: item,
                                              key: index
                                            }, _toDisplayString(item), 9, _hoisted_290))
                                          }), 128))
                                        ], 2), [
                                          [_vModelSelect, _unref(vCheckbox$).additional_information_select1.$model]
                                        ]),
                                        _createVNode(InputErrorMessage, {
                                          title: _unref(communityRequiredData).additional_information_1_question,
                                          validator: _unref(vCheckbox$).additional_information_select1.$errors[0]?.$validator
                                        }, null, 8, ["title", "validator"])
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_291, [
                                      _createElementVNode("div", _hoisted_292, [
                                        _createElementVNode("div", _hoisted_293, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(communityRequiredData)?.additional_information_1_setting?.data, (item, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              class: _normalizeClass(["mt-1 col-xs-12 col-md-6 col-lg-4 d-flex word-wrapper", [_unref(vCheckbox$).additional_information_checkbox1.$error ? 'is-invalid' : '']]),
                                              key: index
                                            }, [
                                              _createElementVNode("label", _hoisted_294, [
                                                _withDirectives(_createElementVNode("input", {
                                                  type: "checkbox",
                                                  class: "mr-1 cursor-pointer form-check-input",
                                                  value: `${item}_ALUMNI_IDX_${index}`,
                                                  "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((additional_information_checkbox.value.additional_information_checkbox1) = $event))
                                                }, null, 8, _hoisted_295), [
                                                  [_vModelCheckbox, additional_information_checkbox.value.additional_information_checkbox1]
                                                ]),
                                                _createElementVNode("div", _hoisted_296, _toDisplayString(item), 1)
                                              ])
                                            ], 2))
                                          }), 128)),
                                          _createVNode(InputErrorMessage, {
                                            title: _unref(communityRequiredData).additional_information_1_question,
                                            params: [1, 100],
                                            validator: _unref(vCheckbox$).additional_information_checkbox1.$errors[0]?.$validator
                                          }, null, 8, ["title", "validator"])
                                        ])
                                      ])
                                    ]))
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(communityRequiredData).additional_information_2 === 1 || _unref(communityRequiredData).additional_information_2 === 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_297, [
                              _createElementVNode("label", _hoisted_298, [
                                _createTextVNode(_toDisplayString(_unref(communityRequiredData).additional_information_2_question) + " ", 1),
                                (
                  _unref(communityRequiredData)?.additional_information_2_setting?.type == _unref(ALUMNI_QUESTION_TYPE).MULTIPLE_CHOICE &&
                  _unref(communityRequiredData)?.additional_information_2_setting?.data?.length > 1
                )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_299, _toDisplayString(_unref(translate)('multipleSelectionsPossible')), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_300, [
                                (_unref(communityRequiredData).additional_information_2 === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_301, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              (_unref(communityRequiredData)?.additional_information_2_setting?.type == _unref(ALUMNI_QUESTION_TYPE).FREE_TEXT)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_302, [
                                    _createElementVNode("div", _hoisted_303, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: _normalizeClass(['form-control', ngKeyAdditionalInformation2.value || _unref(v$).additional_information_2.$error ? 'is-invalid' : '']),
                                        "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_unref(v$).additional_information_2.$model) = $event)),
                                        onChange: _cache[63] || (_cache[63] = 
//@ts-ignore
(...args) => (_unref(checkNGAdditionalInformation2) && _unref(checkNGAdditionalInformation2)(...args))),
                                        placeholder: _unref(placeholderDefault),
                                        name: "additional_information_2"
                                      }, null, 42, _hoisted_304), [
                                        [
                                          _vModelText,
                                          _unref(v$).additional_information_2.$model,
                                          void 0,
                                          { trim: true }
                                        ]
                                      ]),
                                      (ngKeyAdditionalInformation2.value && !_unref(v$).additional_information_2.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_305, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                        : _createCommentVNode("", true),
                                      _createVNode(InputErrorMessage, {
                                        title: _unref(communityRequiredData).additional_information_2_question,
                                        params: [1, 100],
                                        validator: _unref(v$).additional_information_2.$errors[0]?.$validator
                                      }, null, 8, ["title", "validator"])
                                    ])
                                  ]))
                                : (_unref(communityRequiredData)?.additional_information_2_setting?.type == _unref(ALUMNI_QUESTION_TYPE).SINGLE_CHOICE)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_306, [
                                      _createElementVNode("div", _hoisted_307, [
                                        _withDirectives(_createElementVNode("select", {
                                          class: _normalizeClass(["form-select", ['form-control', _unref(vCheckbox$).additional_information_select2.$error ? 'is-invalid' : '']]),
                                          "aria-label": "Default select example",
                                          "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_unref(vCheckbox$).additional_information_select2.$model) = $event)),
                                          ref: (_value, _refs) => {
                                            _refs['selectChild'] = _value
                                            selectChild.value = _value
                                          }
                                        }, [
                                          _createElementVNode("option", _hoisted_308, _toDisplayString(_unref(translate)('placeholderSelect')), 1),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(communityRequiredData)?.additional_information_2_setting?.data, (item, index) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                              value: item,
                                              key: index
                                            }, _toDisplayString(item), 9, _hoisted_309))
                                          }), 128))
                                        ], 2), [
                                          [_vModelSelect, _unref(vCheckbox$).additional_information_select2.$model]
                                        ]),
                                        _createVNode(InputErrorMessage, {
                                          title: _unref(communityRequiredData).additional_information_2_question,
                                          validator: _unref(vCheckbox$).additional_information_select2.$errors[0]?.$validator
                                        }, null, 8, ["title", "validator"])
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_310, [
                                      _createElementVNode("div", _hoisted_311, [
                                        _createElementVNode("div", _hoisted_312, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(communityRequiredData)?.additional_information_2_setting?.data, (item, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              class: _normalizeClass(["mt-1 col-xs-12 col-md-6 col-lg-4 d-flex word-wrapper", [_unref(vCheckbox$).additional_information_checkbox2.$error ? 'is-invalid' : '']]),
                                              key: index
                                            }, [
                                              _createElementVNode("label", _hoisted_313, [
                                                _withDirectives(_createElementVNode("input", {
                                                  type: "checkbox",
                                                  class: "mr-1 cursor-pointer form-check-input",
                                                  value: `${item}_ALUMNI_IDX_${index}`,
                                                  "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((additional_information_checkbox.value.additional_information_checkbox2) = $event))
                                                }, null, 8, _hoisted_314), [
                                                  [_vModelCheckbox, additional_information_checkbox.value.additional_information_checkbox2]
                                                ]),
                                                _createElementVNode("div", _hoisted_315, _toDisplayString(item), 1)
                                              ])
                                            ], 2))
                                          }), 128)),
                                          _createVNode(InputErrorMessage, {
                                            title: _unref(communityRequiredData).additional_information_2_question,
                                            params: [1, 100],
                                            validator: _unref(vCheckbox$).additional_information_checkbox2.$errors[0]?.$validator
                                          }, null, 8, ["title", "validator"])
                                        ])
                                      ])
                                    ]))
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(communityRequiredData).additional_information_3 === 1 || _unref(communityRequiredData).additional_information_3 === 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_316, [
                              _createElementVNode("label", _hoisted_317, [
                                _createTextVNode(_toDisplayString(_unref(communityRequiredData).additional_information_3_question) + " ", 1),
                                (
                  _unref(communityRequiredData)?.additional_information_3_setting?.type == _unref(ALUMNI_QUESTION_TYPE).MULTIPLE_CHOICE &&
                  _unref(communityRequiredData)?.additional_information_3_setting?.data?.length > 1
                )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_318, _toDisplayString(_unref(translate)('multipleSelectionsPossible')), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_319, [
                                (_unref(communityRequiredData).additional_information_3 === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_320, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              (_unref(communityRequiredData)?.additional_information_3_setting?.type == _unref(ALUMNI_QUESTION_TYPE).FREE_TEXT)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_321, [
                                    _createElementVNode("div", _hoisted_322, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: _normalizeClass(['form-control', ngKeyAdditionalInformation3.value || _unref(v$).additional_information_3.$error ? 'is-invalid' : '']),
                                        "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_unref(v$).additional_information_3.$model) = $event)),
                                        onChange: _cache[67] || (_cache[67] = 
//@ts-ignore
(...args) => (_unref(checkNGAdditionalInformation3) && _unref(checkNGAdditionalInformation3)(...args))),
                                        placeholder: _unref(placeholderDefault),
                                        name: "additional_information_3"
                                      }, null, 42, _hoisted_323), [
                                        [
                                          _vModelText,
                                          _unref(v$).additional_information_3.$model,
                                          void 0,
                                          { trim: true }
                                        ]
                                      ]),
                                      (ngKeyAdditionalInformation3.value && !_unref(v$).additional_information_3.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_324, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                        : _createCommentVNode("", true),
                                      _createVNode(InputErrorMessage, {
                                        title: _unref(communityRequiredData).additional_information_3_question,
                                        params: [1, 100],
                                        validator: _unref(v$).additional_information_3.$errors[0]?.$validator
                                      }, null, 8, ["title", "validator"])
                                    ])
                                  ]))
                                : (_unref(communityRequiredData)?.additional_information_3_setting?.type == _unref(ALUMNI_QUESTION_TYPE).SINGLE_CHOICE)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_325, [
                                      _createElementVNode("div", _hoisted_326, [
                                        _withDirectives(_createElementVNode("select", {
                                          class: _normalizeClass(["form-select", ['form-control', _unref(vCheckbox$).additional_information_select3.$error ? 'is-invalid' : '']]),
                                          "aria-label": "Default select example",
                                          "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_unref(vCheckbox$).additional_information_select3.$model) = $event)),
                                          ref: (_value, _refs) => {
                                            _refs['selectChild'] = _value
                                            selectChild.value = _value
                                          }
                                        }, [
                                          _createElementVNode("option", _hoisted_327, _toDisplayString(_unref(translate)('placeholderSelect')), 1),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(communityRequiredData)?.additional_information_3_setting?.data, (item, index) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                              value: item,
                                              key: index
                                            }, _toDisplayString(item), 9, _hoisted_328))
                                          }), 128))
                                        ], 2), [
                                          [_vModelSelect, _unref(vCheckbox$).additional_information_select3.$model]
                                        ]),
                                        _createVNode(InputErrorMessage, {
                                          title: _unref(communityRequiredData).additional_information_3_question,
                                          validator: _unref(vCheckbox$).additional_information_select3.$errors[0]?.$validator
                                        }, null, 8, ["title", "validator"])
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_329, [
                                      _createElementVNode("div", _hoisted_330, [
                                        _createElementVNode("div", _hoisted_331, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(communityRequiredData)?.additional_information_3_setting?.data, (item, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              class: _normalizeClass(["mt-1 col-xs-12 col-md-6 col-lg-4 d-flex word-wrapper", [_unref(vCheckbox$).additional_information_checkbox3.$error ? 'is-invalid' : '']]),
                                              key: index
                                            }, [
                                              _createElementVNode("label", _hoisted_332, [
                                                _withDirectives(_createElementVNode("input", {
                                                  type: "checkbox",
                                                  class: "mr-1 cursor-pointer form-check-input",
                                                  value: `${item}_ALUMNI_IDX_${index}`,
                                                  "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((additional_information_checkbox.value.additional_information_checkbox3) = $event))
                                                }, null, 8, _hoisted_333), [
                                                  [_vModelCheckbox, additional_information_checkbox.value.additional_information_checkbox3]
                                                ]),
                                                _createElementVNode("div", _hoisted_334, _toDisplayString(item), 1)
                                              ])
                                            ], 2))
                                          }), 128)),
                                          _createVNode(InputErrorMessage, {
                                            title: _unref(communityRequiredData).additional_information_3_question,
                                            params: [1, 100],
                                            validator: _unref(vCheckbox$).additional_information_checkbox3.$errors[0]?.$validator
                                          }, null, 8, ["title", "validator"])
                                        ])
                                      ])
                                    ]))
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(communityRequiredData).additional_information_4 === 1 || _unref(communityRequiredData).additional_information_4 === 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_335, [
                              _createElementVNode("label", _hoisted_336, [
                                _createTextVNode(_toDisplayString(_unref(communityRequiredData).additional_information_4_question) + " ", 1),
                                (
                  _unref(communityRequiredData)?.additional_information_4_setting?.type == _unref(ALUMNI_QUESTION_TYPE).MULTIPLE_CHOICE &&
                  _unref(communityRequiredData)?.additional_information_4_setting?.data?.length > 1
                )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_337, _toDisplayString(_unref(translate)('multipleSelectionsPossible')), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_338, [
                                (_unref(communityRequiredData).additional_information_4 === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_339, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              (_unref(communityRequiredData)?.additional_information_4_setting?.type == _unref(ALUMNI_QUESTION_TYPE).FREE_TEXT)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_340, [
                                    _createElementVNode("div", _hoisted_341, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: _normalizeClass(['form-control', ngKeyAdditionalInformation4.value || _unref(v$).additional_information_4.$error ? 'is-invalid' : '']),
                                        "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_unref(v$).additional_information_4.$model) = $event)),
                                        onChange: _cache[71] || (_cache[71] = 
//@ts-ignore
(...args) => (_unref(checkNGAdditionalInformation4) && _unref(checkNGAdditionalInformation4)(...args))),
                                        placeholder: _unref(placeholderDefault),
                                        name: "additional_information_4"
                                      }, null, 42, _hoisted_342), [
                                        [
                                          _vModelText,
                                          _unref(v$).additional_information_4.$model,
                                          void 0,
                                          { trim: true }
                                        ]
                                      ]),
                                      (ngKeyAdditionalInformation4.value && !_unref(v$).additional_information_4.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_343, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                        : _createCommentVNode("", true),
                                      _createVNode(InputErrorMessage, {
                                        title: _unref(communityRequiredData).additional_information_4_question,
                                        params: [1, 100],
                                        validator: _unref(v$).additional_information_4.$errors[0]?.$validator
                                      }, null, 8, ["title", "validator"])
                                    ])
                                  ]))
                                : (_unref(communityRequiredData)?.additional_information_4_setting?.type == _unref(ALUMNI_QUESTION_TYPE).SINGLE_CHOICE)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_344, [
                                      _createElementVNode("div", _hoisted_345, [
                                        _withDirectives(_createElementVNode("select", {
                                          class: _normalizeClass(["form-select", ['form-control', _unref(vCheckbox$).additional_information_select4.$error ? 'is-invalid' : '']]),
                                          "aria-label": "Default select example",
                                          "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_unref(vCheckbox$).additional_information_select4.$model) = $event)),
                                          ref: (_value, _refs) => {
                                            _refs['selectChild'] = _value
                                            selectChild.value = _value
                                          }
                                        }, [
                                          _createElementVNode("option", _hoisted_346, _toDisplayString(_unref(translate)('placeholderSelect')), 1),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(communityRequiredData)?.additional_information_4_setting?.data, (item, index) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                              value: item,
                                              key: index
                                            }, _toDisplayString(item), 9, _hoisted_347))
                                          }), 128))
                                        ], 2), [
                                          [_vModelSelect, _unref(vCheckbox$).additional_information_select4.$model]
                                        ]),
                                        _createVNode(InputErrorMessage, {
                                          title: _unref(communityRequiredData).additional_information_4_question,
                                          validator: _unref(vCheckbox$).additional_information_select4.$errors[0]?.$validator
                                        }, null, 8, ["title", "validator"])
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_348, [
                                      _createElementVNode("div", _hoisted_349, [
                                        _createElementVNode("div", _hoisted_350, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(communityRequiredData)?.additional_information_4_setting?.data, (item, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              class: _normalizeClass(["mt-1 col-xs-12 col-md-6 col-lg-4 d-flex word-wrapper", [_unref(vCheckbox$).additional_information_checkbox4.$error ? 'is-invalid' : '']]),
                                              key: index
                                            }, [
                                              _createElementVNode("label", _hoisted_351, [
                                                _withDirectives(_createElementVNode("input", {
                                                  type: "checkbox",
                                                  class: "mr-1 cursor-pointer form-check-input",
                                                  value: `${item}_ALUMNI_IDX_${index}`,
                                                  "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((additional_information_checkbox.value.additional_information_checkbox4) = $event))
                                                }, null, 8, _hoisted_352), [
                                                  [_vModelCheckbox, additional_information_checkbox.value.additional_information_checkbox4]
                                                ]),
                                                _createElementVNode("div", _hoisted_353, _toDisplayString(item), 1)
                                              ])
                                            ], 2))
                                          }), 128)),
                                          _createVNode(InputErrorMessage, {
                                            title: _unref(communityRequiredData).additional_information_4_question,
                                            params: [1, 100],
                                            validator: _unref(vCheckbox$).additional_information_checkbox4.$errors[0]?.$validator
                                          }, null, 8, ["title", "validator"])
                                        ])
                                      ])
                                    ]))
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(communityRequiredData).additional_information_5 === 1 || _unref(communityRequiredData).additional_information_5 === 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_354, [
                              _createElementVNode("label", _hoisted_355, [
                                _createTextVNode(_toDisplayString(_unref(communityRequiredData).additional_information_5_question) + " ", 1),
                                (
                  _unref(communityRequiredData)?.additional_information_5_setting?.type == _unref(ALUMNI_QUESTION_TYPE).MULTIPLE_CHOICE &&
                  _unref(communityRequiredData)?.additional_information_5_setting?.data?.length > 1
                )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_356, _toDisplayString(_unref(translate)('multipleSelectionsPossible')), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_357, [
                                (_unref(communityRequiredData).additional_information_5 === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_358, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              (_unref(communityRequiredData)?.additional_information_5_setting?.type == _unref(ALUMNI_QUESTION_TYPE).FREE_TEXT)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_359, [
                                    _createElementVNode("div", _hoisted_360, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: _normalizeClass(['form-control', ngKeyAdditionalInformation5.value || _unref(v$).additional_information_5.$error ? 'is-invalid' : '']),
                                        "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_unref(v$).additional_information_5.$model) = $event)),
                                        onChange: _cache[75] || (_cache[75] = 
//@ts-ignore
(...args) => (_unref(checkNGAdditionalInformation5) && _unref(checkNGAdditionalInformation5)(...args))),
                                        placeholder: _unref(placeholderDefault),
                                        name: "additional_information_5"
                                      }, null, 42, _hoisted_361), [
                                        [
                                          _vModelText,
                                          _unref(v$).additional_information_5.$model,
                                          void 0,
                                          { trim: true }
                                        ]
                                      ]),
                                      (ngKeyAdditionalInformation5.value && !_unref(v$).additional_information_5.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_362, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                        : _createCommentVNode("", true),
                                      _createVNode(InputErrorMessage, {
                                        title: _unref(communityRequiredData).additional_information_5_question,
                                        params: [1, 100],
                                        validator: _unref(v$).additional_information_5.$errors[0]?.$validator
                                      }, null, 8, ["title", "validator"])
                                    ])
                                  ]))
                                : (_unref(communityRequiredData)?.additional_information_5_setting?.type == _unref(ALUMNI_QUESTION_TYPE).SINGLE_CHOICE)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_363, [
                                      _createElementVNode("div", _hoisted_364, [
                                        _withDirectives(_createElementVNode("select", {
                                          class: _normalizeClass(["form-select", ['form-control', _unref(vCheckbox$).additional_information_select5.$error ? 'is-invalid' : '']]),
                                          "aria-label": "Default select example",
                                          "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((_unref(vCheckbox$).additional_information_select5.$model) = $event)),
                                          ref: (_value, _refs) => {
                                            _refs['selectChild'] = _value
                                            selectChild.value = _value
                                          }
                                        }, [
                                          _createElementVNode("option", _hoisted_365, _toDisplayString(_unref(translate)('placeholderSelect')), 1),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(communityRequiredData)?.additional_information_5_setting?.data, (item, index) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                              value: item,
                                              key: index
                                            }, _toDisplayString(item), 9, _hoisted_366))
                                          }), 128))
                                        ], 2), [
                                          [_vModelSelect, _unref(vCheckbox$).additional_information_select5.$model]
                                        ]),
                                        _createVNode(InputErrorMessage, {
                                          title: _unref(communityRequiredData).additional_information_5_question,
                                          validator: _unref(vCheckbox$).additional_information_select5.$errors[0]?.$validator
                                        }, null, 8, ["title", "validator"])
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_367, [
                                      _createElementVNode("div", _hoisted_368, [
                                        _createElementVNode("div", _hoisted_369, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(communityRequiredData)?.additional_information_5_setting?.data, (item, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              class: _normalizeClass(["mt-1 col-xs-12 col-md-6 col-lg-4 d-flex word-wrapper", [_unref(vCheckbox$).additional_information_checkbox5.$error ? 'is-invalid' : '']]),
                                              key: index
                                            }, [
                                              _createElementVNode("label", _hoisted_370, [
                                                _withDirectives(_createElementVNode("input", {
                                                  type: "checkbox",
                                                  class: "mr-1 cursor-pointer form-check-input",
                                                  value: `${item}_ALUMNI_IDX_${index}`,
                                                  "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((additional_information_checkbox.value.additional_information_checkbox5) = $event))
                                                }, null, 8, _hoisted_371), [
                                                  [_vModelCheckbox, additional_information_checkbox.value.additional_information_checkbox5]
                                                ]),
                                                _createElementVNode("div", _hoisted_372, _toDisplayString(item), 1)
                                              ])
                                            ], 2))
                                          }), 128)),
                                          _createVNode(InputErrorMessage, {
                                            title: _unref(communityRequiredData).additional_information_5_question,
                                            params: [1, 100],
                                            validator: _unref(vCheckbox$).additional_information_checkbox5.$errors[0]?.$validator
                                          }, null, 8, ["title", "validator"])
                                        ])
                                      ])
                                    ]))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_373, [
                    _createElementVNode("h1", _hoisted_374, _toDisplayString(_unref(translate)('SA20termYelloop')), 1),
                    _createElementVNode("div", _hoisted_375, _toDisplayString(_unref(termsYelloop).content), 1),
                    _createElementVNode("div", _hoisted_376, [
                      _createElementVNode("label", _hoisted_377, [
                        _withDirectives(_createElementVNode("input", {
                          id: "consent_of_yelloop",
                          type: "checkbox",
                          class: "mr-1 cursor-pointer form-check-input",
                          "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((formData.value.consent_of_yelloop) = $event)),
                          name: "consent_of_yelloop"
                        }, null, 512), [
                          [_vModelCheckbox, formData.value.consent_of_yelloop]
                        ]),
                        _createTextVNode(" " + _toDisplayString(_unref(translate)('SA20yelloopCheck')), 1)
                      ])
                    ]),
                    (!formData.value.consent_of_yelloop && checkSubmit.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_378, _toDisplayString(_unref(translate)('SA20yelloopError')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_379, [
                    _createElementVNode("h1", _hoisted_380, _toDisplayString(_unref(inviteData).community_name) + _toDisplayString(_unref(translate)('SA20community')), 1),
                    _createElementVNode("div", _hoisted_381, _toDisplayString(_unref(termsCommunity).term_of_service), 1),
                    _createElementVNode("div", _hoisted_382, [
                      _createElementVNode("label", _hoisted_383, [
                        _withDirectives(_createElementVNode("input", {
                          id: "consent_of_community",
                          type: "checkbox",
                          class: "mr-1 cursor-pointer form-check-input",
                          "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((formData.value.consent_of_community) = $event)),
                          name: "consent_of_community"
                        }, null, 512), [
                          [_vModelCheckbox, formData.value.consent_of_community]
                        ]),
                        _createTextVNode(" " + _toDisplayString(_unref(inviteData).community_name) + _toDisplayString(_unref(translate)('agreeLeaderShip')), 1)
                      ])
                    ]),
                    (!formData.value.consent_of_community && checkSubmit.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_384, _toDisplayString(_unref(inviteData).community_name) + _toDisplayString(_unref(translate)('SA20communityError')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_385, [
                    _createVNode(Button, {
                      title: _unref(translate)('titleConfirm'),
                      type: 'secondary',
                      onClick: onSubmit,
                      disabled: disableBtn.value
                    }, null, 8, ["title", "disabled"])
                  ])
                ], 32)
              ]))
      ]))
}
}

})